import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImpiantiremotiService {

  constructor() { }
  

     getData() {
        return {
          'MS':
            [
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.0,
                "art_comp": "XMS073984",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073984"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.0,
                "art_comp": "XMS073994",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073994"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 2.7,
                "art_comp": "XMS073984",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073984"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 2.7,
                "art_comp": "XMS073994",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073994"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.8,
                "art_comp": "XMS073985",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073985"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.8,
                "art_comp": "XMS073995",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073995"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 3.3,
                "art_comp": "XMS073984",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073984"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 3.3,
                "art_comp": "XMS073994",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073994"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 3.9,
                "art_comp": "XMS073985",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073985"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 3.9,
                "art_comp": "XMS073995",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073995"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 4.3,
                "art_comp": "XMS073984",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073984"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 4.3,
                "art_comp": "XMS073994",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073994"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.5,
                "art_comp": "XMS073980",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073980"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.5,
                "art_comp": "XMS073985",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073985"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.5,
                "art_comp": "XMS073990",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073990"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.5,
                "art_comp": "XMS073995",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073995"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.5,
                "art_comp": "XMS073986",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073986"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.5,
                "art_comp": "XMS073996",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073996"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 5.6,
                "art_comp": "XMS073980",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073980"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 5.6,
                "art_comp": "XMS073990",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073990"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.7,
                "art_comp": "XMS073980",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073980"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.7,
                "art_comp": "XMS073981",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073981"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 5.7,
                "art_comp": "XMS073985",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073985"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.7,
                "art_comp": "XMS073990",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073990"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.7,
                "art_comp": "XMS073991",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073991"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 5.7,
                "art_comp": "XMS073995",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073995"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.7,
                "art_comp": "XMS073981",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073981"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.7,
                "art_comp": "XMS073991",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073991"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.8,
                "art_comp": "XMS073980",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073980"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.8,
                "art_comp": "XMS073990",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073990"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.9,
                "art_comp": "XMS073980",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073980"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.9,
                "art_comp": "XMS073981",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073981"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.9,
                "art_comp": "XMS073990",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073990"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.9,
                "art_comp": "XMS073991",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073991"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XMS073986",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073986"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XMS073996",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073996"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.9,
                "art_comp": "XMS073981",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073981"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.9,
                "art_comp": "XMS073991",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073991"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XMS073981",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073981"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XMS073986",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073986"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XMS073991",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073991"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XMS073996",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073996"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 8.4,
                "art_comp": "XMS073980",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073980"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 8.4,
                "art_comp": "XMS073990",
                "tipoImpianto": "4P",
                "stock": "NO",
                "art_comp_nipote": "MS073990"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.5,
                "art_comp": "XMS073982",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073982"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.5,
                "art_comp": "XMS073992",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073992"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.5,
                "art_comp": "XMS073981",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073981"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.5,
                "art_comp": "XMS073991",
                "tipoImpianto": "7P",
                "stock": "NO",
                "art_comp_nipote": "MS073991"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.9,
                "art_comp": "XMS073982",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073982"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.9,
                "art_comp": "XMS073992",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073992"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.5,
                "art_comp": "XMS073986",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073986"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.5,
                "art_comp": "XMS073996",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073996"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 10.6,
                "art_comp": "XMS073982",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073982"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 10.6,
                "art_comp": "XMS073992",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073992"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 12.5,
                "art_comp": "XMS073982",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073982"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 12.5,
                "art_comp": "XMS073982",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073982"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 12.5,
                "art_comp": "XMS073992",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073992"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 12.5,
                "art_comp": "XMS073992",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073992"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 13.0,
                "art_comp": "XMS073983",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073983"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 13.0,
                "art_comp": "XMS073993",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073993"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 13.9,
                "art_comp": "XMS073983",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073983"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 13.9,
                "art_comp": "XMS073993",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073993"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 14.0,
                "art_comp": "XMS073982",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073982"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 14.0,
                "art_comp": "XMS073992",
                "tipoImpianto": "13P",
                "stock": "NO",
                "art_comp_nipote": "MS073992"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 15.0,
                "art_comp": "XMS073983",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073983"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 15.0,
                "art_comp": "XMS073993",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073993"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.0,
                "art_comp": "XMS073983",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073983"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 17.0,
                "art_comp": "XMS073983",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073983"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.0,
                "art_comp": "XMS073993",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073993"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 17.0,
                "art_comp": "XMS073993",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073993"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 20.5,
                "art_comp": "XMS073983",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073983"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 20.5,
                "art_comp": "XMS073993",
                "tipoImpianto": "16P",
                "stock": "NO",
                "art_comp_nipote": "MS073993"
              }
            ],
          'MISAERM':
            [
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.8,
                "art_comp": "XMS073657",
                "tipoImpianto": "MEN 6",
                "stock": "NO",
                "art_comp_nipote": "MS073657"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 3.9,
                "art_comp": "XMS073657",
                "tipoImpianto": "MEN 6",
                "stock": "NO",
                "art_comp_nipote": "MS073657"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.5,
                "art_comp": "XMS073657",
                "tipoImpianto": "MEN 6",
                "stock": "NO",
                "art_comp_nipote": "MS073657"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.5,
                "art_comp": "XMS073658",
                "tipoImpianto": "MEN13",
                "stock": "NO",
                "art_comp_nipote": "MS073658"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.7,
                "art_comp": "XMS073650",
                "tipoImpianto": "MEP 7",
                "stock": "NO",
                "art_comp_nipote": "MS073650"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 5.7,
                "art_comp": "XMS073657",
                "tipoImpianto": "MEN 6",
                "stock": "NO",
                "art_comp_nipote": "MS073657"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.7,
                "art_comp": "XMS073650",
                "tipoImpianto": "MEP 7",
                "stock": "NO",
                "art_comp_nipote": "MS073650"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.9,
                "art_comp": "XMS073650",
                "tipoImpianto": "MEP 7",
                "stock": "NO",
                "art_comp_nipote": "MS073650"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.0,
                "art_comp": "XMS073658",
                "tipoImpianto": "MEN13",
                "stock": "NO",
                "art_comp_nipote": "MS073658"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.9,
                "art_comp": "XMS073650",
                "tipoImpianto": "MEP 7",
                "stock": "NO",
                "art_comp_nipote": "MS073650"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XMS073650",
                "tipoImpianto": "MEP 7",
                "stock": "NO",
                "art_comp_nipote": "MS073650"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XMS073658",
                "tipoImpianto": "MEN13",
                "stock": "NO",
                "art_comp_nipote": "MS073658"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.5,
                "art_comp": "XMS073651",
                "tipoImpianto": "MEP13",
                "stock": "NO",
                "art_comp_nipote": "MS073651"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.5,
                "art_comp": "XMS073650",
                "tipoImpianto": "MEP 7",
                "stock": "NO",
                "art_comp_nipote": "MS073650"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.9,
                "art_comp": "XMS073651",
                "tipoImpianto": "MEP13",
                "stock": "NO",
                "art_comp_nipote": "MS073651"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 10.0,
                "art_comp": "XMS073659",
                "tipoImpianto": "MEN20",
                "stock": "NO",
                "art_comp_nipote": "MS073659"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 10.0,
                "art_comp": "XMS073664",
                "tipoImpianto": "MEN20",
                "stock": "NO",
                "art_comp_nipote": "MS073664"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.5,
                "art_comp": "XMS073658",
                "tipoImpianto": "MEN13",
                "stock": "NO",
                "art_comp_nipote": "MS073658"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 10.6,
                "art_comp": "XMS073651",
                "tipoImpianto": "MEP13",
                "stock": "NO",
                "art_comp_nipote": "MS073651"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 12.5,
                "art_comp": "XMS073651",
                "tipoImpianto": "MEP13",
                "stock": "NO",
                "art_comp_nipote": "MS073651"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 12.5,
                "art_comp": "XMS073651",
                "tipoImpianto": "MEP13",
                "stock": "NO",
                "art_comp_nipote": "MS073651"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 12.7,
                "art_comp": "XMS073659",
                "tipoImpianto": "MEN20",
                "stock": "NO",
                "art_comp_nipote": "MS073659"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 12.7,
                "art_comp": "XMS073664",
                "tipoImpianto": "MEN20",
                "stock": "NO",
                "art_comp_nipote": "MS073664"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 13.0,
                "art_comp": "XMS073652",
                "tipoImpianto": "MEP16",
                "stock": "NO",
                "art_comp_nipote": "MS073652"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 13.9,
                "art_comp": "XMS073652",
                "tipoImpianto": "MEP16",
                "stock": "NO",
                "art_comp_nipote": "MS073652"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 14.0,
                "art_comp": "XMS073651",
                "tipoImpianto": "MEP13",
                "stock": "NO",
                "art_comp_nipote": "MS073651"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.4,
                "art_comp": "XMS073653",
                "tipoImpianto": "MEP18",
                "stock": "NO",
                "art_comp_nipote": "MS073653"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.8,
                "art_comp": "XMS073659",
                "tipoImpianto": "MEN20",
                "stock": "NO",
                "art_comp_nipote": "MS073659"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.8,
                "art_comp": "XMS073664",
                "tipoImpianto": "MEN20",
                "stock": "NO",
                "art_comp_nipote": "MS073664"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 15.0,
                "art_comp": "XMS073652",
                "tipoImpianto": "MEP16",
                "stock": "NO",
                "art_comp_nipote": "MS073652"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 16.1,
                "art_comp": "XMS073660",
                "tipoImpianto": "MEN28",
                "stock": "NO",
                "art_comp_nipote": "MS073660"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 16.2,
                "art_comp": "XMS073653",
                "tipoImpianto": "MEP18",
                "stock": "NO",
                "art_comp_nipote": "MS073653"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 17.0,
                "art_comp": "XMS073652",
                "tipoImpianto": "MEP16",
                "stock": "NO",
                "art_comp_nipote": "MS073652"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.0,
                "art_comp": "XMS073652",
                "tipoImpianto": "MEP16",
                "stock": "NO",
                "art_comp_nipote": "MS073652"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.4,
                "art_comp": "XMS073653",
                "tipoImpianto": "MEP18",
                "stock": "NO",
                "art_comp_nipote": "MS073653"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.8,
                "art_comp": "XMS073654",
                "tipoImpianto": "MEP26",
                "stock": "NO",
                "art_comp_nipote": "MS073654"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 18.6,
                "art_comp": "XMS073659",
                "tipoImpianto": "MEN20",
                "stock": "NO",
                "art_comp_nipote": "MS073659"
              },
              {
                "Standard-Clienti": "Clienti",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 18.6,
                "art_comp": "XMS073664",
                "tipoImpianto": "MEN20",
                "stock": "NO",
                "art_comp_nipote": "MS073664"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 20.0,
                "art_comp": "XMS073653",
                "tipoImpianto": "MEP18",
                "stock": "NO",
                "art_comp_nipote": "MS073653"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 20.0,
                "art_comp": "XMS073654",
                "tipoImpianto": "MEP26",
                "stock": "NO",
                "art_comp_nipote": "MS073654"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 20.2,
                "art_comp": "XMS073653",
                "tipoImpianto": "MEP18",
                "stock": "NO",
                "art_comp_nipote": "MS073653"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 20.4,
                "art_comp": "XMS073660",
                "tipoImpianto": "MEN28",
                "stock": "NO",
                "art_comp_nipote": "MS073660"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 20.5,
                "art_comp": "XMS073652",
                "tipoImpianto": "MEP16",
                "stock": "NO",
                "art_comp_nipote": "MS073652"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 21.5,
                "art_comp": "XMS073654",
                "tipoImpianto": "MEP26",
                "stock": "NO",
                "art_comp_nipote": "MS073654"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 22.6,
                "art_comp": "XMS073653",
                "tipoImpianto": "MEP18",
                "stock": "NO",
                "art_comp_nipote": "MS073653"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 22.6,
                "art_comp": "XMS073655",
                "tipoImpianto": "MEP50",
                "stock": "NO",
                "art_comp_nipote": "MS073655"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 23.8,
                "art_comp": "XMS073660",
                "tipoImpianto": "MEN28",
                "stock": "NO",
                "art_comp_nipote": "MS073660"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 25.0,
                "art_comp": "XMS073654",
                "tipoImpianto": "MEP26",
                "stock": "NO",
                "art_comp_nipote": "MS073654"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 25.4,
                "art_comp": "XMS073654",
                "tipoImpianto": "MEP26",
                "stock": "NO",
                "art_comp_nipote": "MS073654"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 27.5,
                "art_comp": "XMS073655",
                "tipoImpianto": "MEP50",
                "stock": "NO",
                "art_comp_nipote": "MS073655"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 27.5,
                "art_comp": "XMS073655",
                "tipoImpianto": "MEP50",
                "stock": "NO",
                "art_comp_nipote": "MS073655"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 28.7,
                "art_comp": "XMS073654",
                "tipoImpianto": "MEP26",
                "stock": "NO",
                "art_comp_nipote": "MS073654"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 29.6,
                "art_comp": "XMS073656",
                "tipoImpianto": "MEP70",
                "stock": "NO",
                "art_comp_nipote": "MS073656"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 30.0,
                "art_comp": "XMS073660",
                "tipoImpianto": "MEN28",
                "stock": "NO",
                "art_comp_nipote": "MS073660"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 32.7,
                "art_comp": "XMS073655",
                "tipoImpianto": "MEP50",
                "stock": "NO",
                "art_comp_nipote": "MS073655"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 33.1,
                "art_comp": "XMS073655",
                "tipoImpianto": "MEP50",
                "stock": "NO",
                "art_comp_nipote": "MS073655"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 36.0,
                "art_comp": "XMS073656",
                "tipoImpianto": "MEP70",
                "stock": "NO",
                "art_comp_nipote": "MS073656"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 36.0,
                "art_comp": "XMS073656",
                "tipoImpianto": "MEP70",
                "stock": "NO",
                "art_comp_nipote": "MS073656"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 38.2,
                "art_comp": "XMS073655",
                "tipoImpianto": "MEP50",
                "stock": "NO",
                "art_comp_nipote": "MS073655"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 42.9,
                "art_comp": "XMS073656",
                "tipoImpianto": "MEP70",
                "stock": "NO",
                "art_comp_nipote": "MS073656"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 43.3,
                "art_comp": "XMS073656",
                "tipoImpianto": "MEP70",
                "stock": "NO",
                "art_comp_nipote": "MS073656"
              },
              {
                "Standard-Clienti": "Standard",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 50.1,
                "art_comp": "XMS073656",
                "tipoImpianto": "MEP70",
                "stock": "NO",
                "art_comp_nipote": "MS073656"
              }
            ],
          'MSG':
            [
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.0,
                "art_comp": "XC0460531",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "C0460531"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.0,
                "art_comp": "XMS073910",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073910"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.0,
                "art_comp": "XC0460531",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "C0460531"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 2.7,
                "art_comp": "XC0460531",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "C0460531"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 2.7,
                "art_comp": "XMS073910",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073910"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 2.7,
                "art_comp": "XC0450231",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "C0450231"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.8,
                "art_comp": "XC0460532",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "C0460532"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.8,
                "art_comp": "XMS073911",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073911"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 2.8,
                "art_comp": "XC0450232",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "C0450232"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 3.3,
                "art_comp": "XC0460531",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "C0460531"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 3.3,
                "art_comp": "XMS073910",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073910"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 3.3,
                "art_comp": "XC0450231",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "C0450231"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 3.9,
                "art_comp": "XC0460532",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "C0460532"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 3.9,
                "art_comp": "XMS073911",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073911"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 3.9,
                "art_comp": "XC0450232",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "C0450232"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 4.3,
                "art_comp": "XC0460531",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "C0460531"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 4.3,
                "art_comp": "XMS073910",
                "tipoImpianto": "5N",
                "stock": "NO",
                "art_comp_nipote": "MS073910"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 4.3,
                "art_comp": "XC0450231",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "C0450231"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.5,
                "art_comp": "XC0460532",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "C0460532"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.5,
                "art_comp": "XMS073911",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073911"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.5,
                "art_comp": "XC0450232",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "C0450232"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.9,
                "art_comp": "XC0460331",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460331"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.9,
                "art_comp": "XC0460431",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460431"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.9,
                "art_comp": "XMS073900",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073900"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.9,
                "art_comp": "XMS073905",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073905"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 4.9,
                "art_comp": "XC0450131",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450131"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.5,
                "art_comp": "XC0460533",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "C0460533"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.5,
                "art_comp": "XMS073912",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073912"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 5.5,
                "art_comp": "XC0450233",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "C0450233"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 5.7,
                "art_comp": "XC0460532",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "C0460532"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 5.7,
                "art_comp": "XMS073911",
                "tipoImpianto": "6N",
                "stock": "NO",
                "art_comp_nipote": "MS073911"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 5.7,
                "art_comp": "XC0450232",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "C0450232"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.1,
                "art_comp": "XC0460331",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460331"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.1,
                "art_comp": "XC0460431",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460431"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.1,
                "art_comp": "XMS073900",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073900"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.1,
                "art_comp": "XMS073905",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073905"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 6.1,
                "art_comp": "XC0450131",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450131"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XC0460331",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460331"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XC0460332",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460332"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XC0460431",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460431"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XC0460432",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460432"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XMS073900",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073900"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XMS073901",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073901"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XMS073905",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073905"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XMS073906",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073906"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XC0450131",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450131"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 6.2,
                "art_comp": "XC0450132",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450132"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.3,
                "art_comp": "XC0460332",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460332"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.3,
                "art_comp": "XC0460432",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460432"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.3,
                "art_comp": "XMS073901",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073901"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.3,
                "art_comp": "XMS073906",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073906"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.3,
                "art_comp": "XC0450132",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450132"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XC0460331",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460331"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XC0460431",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460431"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XC0460533",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "C0460533"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XMS073900",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073900"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XMS073905",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073905"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XMS073912",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073912"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XC0450131",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450131"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.4,
                "art_comp": "XC0450233",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "C0450233"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.5,
                "art_comp": "XC0460332",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460332"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.5,
                "art_comp": "XC0460432",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460432"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.5,
                "art_comp": "XMS073901",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073901"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.5,
                "art_comp": "XMS073906",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073906"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 7.5,
                "art_comp": "XC0450132",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450132"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.6,
                "art_comp": "XC0460331",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460331"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.6,
                "art_comp": "XC0460431",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460431"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.6,
                "art_comp": "XMS073900",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073900"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.6,
                "art_comp": "XMS073905",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073905"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 7.6,
                "art_comp": "XC0450131",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450131"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XC0460533",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "C0460533"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XMS073912",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073912"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.0,
                "art_comp": "XC0450233",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "C0450233"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 8.6,
                "art_comp": "XC0460332",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460332"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 8.6,
                "art_comp": "XC0460432",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460432"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 8.6,
                "art_comp": "XMS073901",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073901"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 8.6,
                "art_comp": "XMS073906",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073906"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 8.6,
                "art_comp": "XC0450132",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450132"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.8,
                "art_comp": "XC0460332",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460332"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.8,
                "art_comp": "XC0460432",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460432"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.8,
                "art_comp": "XMS073901",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073901"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.8,
                "art_comp": "XMS073906",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073906"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 8.8,
                "art_comp": "XC0450132",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450132"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.2,
                "art_comp": "XC0460331",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460331"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.2,
                "art_comp": "XC0460431",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460431"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.2,
                "art_comp": "XMS073900",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073900"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.2,
                "art_comp": "XMS073905",
                "tipoImpianto": "4P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073905"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 9.2,
                "art_comp": "XC0450131",
                "tipoImpianto": "4P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450131"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 9.3,
                "art_comp": "XC0460333",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460333"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 9.3,
                "art_comp": "XC0460433",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460433"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 9.3,
                "art_comp": "XMS073902",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073902"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 9.3,
                "art_comp": "XMS073907",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073907"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 9.3,
                "art_comp": "XC0450133",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450133"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 10.0,
                "art_comp": "XC0460534",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "C0460534"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 10.0,
                "art_comp": "XMS073913",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "MS073913"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.4,
                "art_comp": "XC0460332",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460332"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.4,
                "art_comp": "XC0460432",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460432"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.4,
                "art_comp": "XMS073901",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073901"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.4,
                "art_comp": "XMS073906",
                "tipoImpianto": "7P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073906"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.4,
                "art_comp": "XC0450132",
                "tipoImpianto": "7P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450132"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.5,
                "art_comp": "XC0460533",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "C0460533"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.5,
                "art_comp": "XMS073912",
                "tipoImpianto": "13N",
                "stock": "NO",
                "art_comp_nipote": "MS073912"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.5,
                "art_comp": "XC0450233",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "C0450233"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.8,
                "art_comp": "XC0460333",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460333"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.8,
                "art_comp": "XC0460433",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460433"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.8,
                "art_comp": "XMS073902",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073902"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.8,
                "art_comp": "XMS073907",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073907"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 10.8,
                "art_comp": "XC0450133",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450133"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 11.6,
                "art_comp": "XC0460333",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460333"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 11.6,
                "art_comp": "XC0460433",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460433"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 11.6,
                "art_comp": "XMS073902",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073902"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 11.6,
                "art_comp": "XMS073907",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073907"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 11.6,
                "art_comp": "XC0450133",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450133"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 12.7,
                "art_comp": "XC0460534",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "C0460534"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 12.7,
                "art_comp": "XMS073913",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "MS073913"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 13.6,
                "art_comp": "XC0460333",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460333"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 13.6,
                "art_comp": "XC0460433",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460433"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 13.6,
                "art_comp": "XMS073902",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073902"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 13.6,
                "art_comp": "XMS073907",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073907"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 13.6,
                "art_comp": "XC0450133",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450133"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 13.7,
                "art_comp": "XC0460333",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460333"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 13.7,
                "art_comp": "XC0460433",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460433"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 13.7,
                "art_comp": "XMS073902",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073902"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 13.7,
                "art_comp": "XMS073907",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073907"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 13.7,
                "art_comp": "XC0450133",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450133"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.8,
                "art_comp": "XC0460534",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "C0460534"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.8,
                "art_comp": "XMS073913",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "MS073913"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.9,
                "art_comp": "XC0460334",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460334"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.9,
                "art_comp": "XC0460434",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460434"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.9,
                "art_comp": "XMS073903",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073903"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.9,
                "art_comp": "XMS073908",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073908"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 14.9,
                "art_comp": "XC0450134",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450134"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.4,
                "art_comp": "XC0460333",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460333"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.4,
                "art_comp": "XC0460433",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460433"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.4,
                "art_comp": "XMS073902",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073902"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.4,
                "art_comp": "XMS073907",
                "tipoImpianto": "13P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073907"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.4,
                "art_comp": "XC0450133",
                "tipoImpianto": "13P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450133"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 15.8,
                "art_comp": "XC0460335",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460335"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 15.8,
                "art_comp": "XC0460435",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460435"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 15.8,
                "art_comp": "XMS073904",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073904"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 15.8,
                "art_comp": "XMS073909",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073909"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.9,
                "art_comp": "XC0460334",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460334"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.9,
                "art_comp": "XC0460434",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460434"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.9,
                "art_comp": "XMS073903",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073903"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.9,
                "art_comp": "XMS073908",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073908"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 15.9,
                "art_comp": "XC0450134",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450134"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.2,
                "art_comp": "XC0460334",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460334"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.2,
                "art_comp": "XC0460434",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460434"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.2,
                "art_comp": "XMS073903",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073903"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.2,
                "art_comp": "XMS073908",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073908"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 17.2,
                "art_comp": "XC0450134",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450134"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 17.8,
                "art_comp": "XC0460335",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460335"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 17.8,
                "art_comp": "XC0460435",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460435"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 17.8,
                "art_comp": "XMS073904",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073904"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 17.8,
                "art_comp": "XMS073909",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073909"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 18.6,
                "art_comp": "XC0460534",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "C0460534"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 18.6,
                "art_comp": "XMS073913",
                "tipoImpianto": "20N",
                "stock": "NO",
                "art_comp_nipote": "MS073913"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.1,
                "art_comp": "XC0460335",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460335"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.1,
                "art_comp": "XC0460435",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460435"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.1,
                "art_comp": "XMS073904",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073904"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.1,
                "art_comp": "XMS073909",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073909"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 19.3,
                "art_comp": "XC0460334",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460334"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 19.3,
                "art_comp": "XC0460434",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460434"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 19.3,
                "art_comp": "XMS073903",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073903"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 19.3,
                "art_comp": "XMS073908",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073908"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 19.3,
                "art_comp": "XC0450134",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450134"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.5,
                "art_comp": "XC0460334",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460334"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.5,
                "art_comp": "XC0460434",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460434"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.5,
                "art_comp": "XMS073903",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073903"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.5,
                "art_comp": "XMS073908",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073908"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 19.5,
                "art_comp": "XC0450134",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450134"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 21.8,
                "art_comp": "XC0460335",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460335"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 21.8,
                "art_comp": "XC0460435",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460435"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 21.8,
                "art_comp": "XMS073904",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073904"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 21.8,
                "art_comp": "XMS073909",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073909"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 22.0,
                "art_comp": "XC0460335",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460335"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 22.0,
                "art_comp": "XC0460435",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460435"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 22.0,
                "art_comp": "XMS073904",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073904"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 22.0,
                "art_comp": "XMS073909",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073909"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 23.5,
                "art_comp": "XC0460334",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460334"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 23.5,
                "art_comp": "XC0460434",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460434"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 23.5,
                "art_comp": "XMS073903",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073903"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 23.5,
                "art_comp": "XMS073908",
                "tipoImpianto": "16P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073908"
              },
              {
                "Controllore": "ELX",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 23.5,
                "art_comp": "XC0450134",
                "tipoImpianto": "16P/6",
                "stock": "NO",
                "art_comp_nipote": "C0450134"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 24.8,
                "art_comp": "XC0460335",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "C0460335"
              },
              {
                "Controllore": "Carel",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 24.8,
                "art_comp": "XC0460435",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "C0460435"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 24.8,
                "art_comp": "XMS073904",
                "tipoImpianto": "18P/6",
                "stock": "NO",
                "art_comp_nipote": "MS073904"
              },
              {
                "Controllore": "Eliwell",
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 24.8,
                "art_comp": "XMS073909",
                "tipoImpianto": "18P/10",
                "stock": "NO",
                "art_comp_nipote": "MS073909"
              }
            ],
          'REFREEX':
            [
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 10,
                "art_comp": "XMSMM0770177",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770177",
                "art_comp_nipote": "MS0770177"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 12,
                "art_comp": "XMSMM0770177",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770177",
                "art_comp_nipote": "MS0770177"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 14,
                "art_comp": "XMSMM0770177",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770177",
                "art_comp_nipote": "MS0770177"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 16,
                "art_comp": "XMSMM0770166",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770166",
                "art_comp_nipote": "MS0770166"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 17,
                "art_comp": "XMSMM0770177",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770177",
                "art_comp_nipote": "MS0770177"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 17,
                "art_comp": "XMSMM0770178",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770178",
                "art_comp_nipote": "MS0770178"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770166",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770166",
                "art_comp_nipote": "MS0770166"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 19,
                "art_comp": "XMSMM0770166",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770166",
                "art_comp_nipote": "MS0770166"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770179",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770179",
                "art_comp_nipote": "MS0770179"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 20,
                "art_comp": "XMSMM0770167",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770167",
                "art_comp_nipote": "MS0770167"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 21,
                "art_comp": "XMSMM0770178",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770178",
                "art_comp_nipote": "MS0770178"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 21,
                "art_comp": "XMSMM0770180",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770180",
                "art_comp_nipote": "MS0770180"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 22,
                "art_comp": "XMSMM0770166",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770166",
                "art_comp_nipote": "MS0770166"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 22,
                "art_comp": "XMSMM0770166",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770166",
                "art_comp_nipote": "MS0770166"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 24,
                "art_comp": "XMSMM0770167",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770167",
                "art_comp_nipote": "MS0770167"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 24,
                "art_comp": "XMSMM0770179",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770179",
                "art_comp_nipote": "MS0770179"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770167",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770167",
                "art_comp_nipote": "MS0770167"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770178",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770178",
                "art_comp_nipote": "MS0770178"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 26,
                "art_comp": "XMSMM0770166",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770166",
                "art_comp_nipote": "MS0770166"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 26,
                "art_comp": "XMSMM0770168",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770168",
                "art_comp_nipote": "MS0770168"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 27,
                "art_comp": "XMSMM0770180",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770180",
                "art_comp_nipote": "MS0770180"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 28,
                "art_comp": "XMSMM0770179",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770179",
                "art_comp_nipote": "MS0770179"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 29,
                "art_comp": "XMSMM0770167",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770167",
                "art_comp_nipote": "MS0770167"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 29,
                "art_comp": "XMSMM0770167",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770167",
                "art_comp_nipote": "MS0770167"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 30,
                "art_comp": "XMSMM0770178",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770178",
                "art_comp_nipote": "MS0770178"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 31,
                "art_comp": "XMSMM0770168",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770168",
                "art_comp_nipote": "MS0770168"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 31,
                "art_comp": "XMSMM0770180",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770180",
                "art_comp_nipote": "MS0770180"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 32,
                "art_comp": "XMSMM0770168",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770168",
                "art_comp_nipote": "MS0770168"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 33,
                "art_comp": "XMSMM0770169",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770169",
                "art_comp_nipote": "MS0770169"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770167",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770167",
                "art_comp_nipote": "MS0770167"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770179",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770179",
                "art_comp_nipote": "MS0770179"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 35,
                "art_comp": "XMSMM0770181",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770181",
                "art_comp_nipote": "MS0770181"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 37,
                "art_comp": "XMSMM0770168",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770168",
                "art_comp_nipote": "MS0770168"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 37,
                "art_comp": "XMSMM0770168",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770168",
                "art_comp_nipote": "MS0770168"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 38,
                "art_comp": "XMSMM0770170",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770170",
                "art_comp_nipote": "MS0770170"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 38,
                "art_comp": "XMSMM0770180",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770180",
                "art_comp_nipote": "MS0770180"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 38,
                "art_comp": "XMSMM0770181",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770181",
                "art_comp_nipote": "MS0770181"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 39,
                "art_comp": "XMSMM0770169",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770169",
                "art_comp_nipote": "MS0770169"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 40,
                "art_comp": "XMSMM0770169",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770169",
                "art_comp_nipote": "MS0770169"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 44,
                "art_comp": "XMSMM0770168",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770168",
                "art_comp_nipote": "MS0770168"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 44,
                "art_comp": "XMSMM0770181",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770181",
                "art_comp_nipote": "MS0770181"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 46,
                "art_comp": "XMSMM0770170",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770170",
                "art_comp_nipote": "MS0770170"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 46,
                "art_comp": "XMSMM0770171",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770171",
                "art_comp_nipote": "MS0770171"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 47,
                "art_comp": "XMSMM0770169",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770169",
                "art_comp_nipote": "MS0770169"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 47,
                "art_comp": "XMSMM0770169",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770169",
                "art_comp_nipote": "MS0770169"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 47,
                "art_comp": "XMSMM0770170",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770170",
                "art_comp_nipote": "MS0770170"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 48,
                "art_comp": "XMSMM0770182",
                "tipoImpianto": "SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770182",
                "art_comp_nipote": "MS0770182"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 54,
                "art_comp": "XMSMM0770170",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770170",
                "art_comp_nipote": "MS0770170"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 54,
                "art_comp": "XMSMM0770170",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770170",
                "art_comp_nipote": "MS0770170"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 55,
                "art_comp": "XMSMM0770169",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770169",
                "art_comp_nipote": "MS0770169"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 58,
                "art_comp": "XMSMM0770171",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770171",
                "art_comp_nipote": "MS0770171"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 59,
                "art_comp": "XMSMM0770172",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770172",
                "art_comp_nipote": "MS0770172"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 62,
                "art_comp": "XMSMM0770181",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770181",
                "art_comp_nipote": "MS0770181"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 62,
                "art_comp": "XMSMM0770183",
                "tipoImpianto": "SEEN 130",
                "stock": "NO",
                "art_comp_figlio": "XMS0770183",
                "art_comp_nipote": "MS0770183"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 65,
                "art_comp": "XMSMM0770170",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770170",
                "art_comp_nipote": "MS0770170"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 67,
                "art_comp": "XMSMM0770173",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770173",
                "art_comp_nipote": "MS0770173"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 72,
                "art_comp": "XMSMM0770171",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770171",
                "art_comp_nipote": "MS0770171"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 72,
                "art_comp": "XMSMM0770172",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770172",
                "art_comp_nipote": "MS0770172"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 74,
                "art_comp": "XMSMM0770171",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770171",
                "art_comp_nipote": "MS0770171"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 76,
                "art_comp": "XMSMM0770182",
                "tipoImpianto": "SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770182",
                "art_comp_nipote": "MS0770182"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 78,
                "art_comp": "XMSMM0770182",
                "tipoImpianto": "SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770182",
                "art_comp_nipote": "MS0770182"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 83,
                "art_comp": "XMSMM0770173",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770173",
                "art_comp_nipote": "MS0770173"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 83,
                "art_comp": "XMSMM0770174",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770174",
                "art_comp_nipote": "MS0770174"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 88,
                "art_comp": "XMSMM0770172",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770172",
                "art_comp_nipote": "MS0770172"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 90,
                "art_comp": "XMSMM0770184",
                "tipoImpianto": "SEEN 150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770184",
                "art_comp_nipote": "MS0770184"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 93,
                "art_comp": "XMSMM0770171",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770171",
                "art_comp_nipote": "MS0770171"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 95,
                "art_comp": "XMSMM0770172",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770172",
                "art_comp_nipote": "MS0770172"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 100,
                "art_comp": "XMSMM0770183",
                "tipoImpianto": "SEEN 130",
                "stock": "NO",
                "art_comp_figlio": "XMS0770183",
                "art_comp_nipote": "MS0770183"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 101,
                "art_comp": "XMSMM0770183",
                "tipoImpianto": "SEEN 130",
                "stock": "NO",
                "art_comp_figlio": "XMS0770183",
                "art_comp_nipote": "MS0770183"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 103,
                "art_comp": "XMSMM0770174",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770174",
                "art_comp_nipote": "MS0770174"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 104,
                "art_comp": "XMSMM0770173",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770173",
                "art_comp_nipote": "MS0770173"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 106,
                "art_comp": "XMSMM0770173",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770173",
                "art_comp_nipote": "MS0770173"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 110,
                "art_comp": "XMSMM0770193",
                "tipoImpianto": "SEEN 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770193",
                "art_comp_nipote": "MS0770193"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 118,
                "art_comp": "XMSMM0770172",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770172",
                "art_comp_nipote": "MS0770172"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 128,
                "art_comp": "XMSMM0770171",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770171",
                "art_comp_nipote": "MS0770171"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 130,
                "art_comp": "XMSMM0770174",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770174",
                "art_comp_nipote": "MS0770174"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 131,
                "art_comp": "XMSMM0770174",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770174",
                "art_comp_nipote": "MS0770174"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 133,
                "art_comp": "XMSMM0770173",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770173",
                "art_comp_nipote": "MS0770173"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 133,
                "art_comp": "XMSMM0770182",
                "tipoImpianto": "SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770182",
                "art_comp_nipote": "MS0770182"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 145,
                "art_comp": "XMSMM0770175",
                "tipoImpianto": "SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770175",
                "art_comp_nipote": "MS0770175"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 147,
                "art_comp": "XMSMM0770184",
                "tipoImpianto": "SEEN 150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770184",
                "art_comp_nipote": "MS0770184"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 152,
                "art_comp": "XMSMM0770191",
                "tipoImpianto": "SEEN 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770191",
                "art_comp_nipote": "MS0770191"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 154,
                "art_comp": "XMSMM0770184",
                "tipoImpianto": "SEEN 150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770184",
                "art_comp_nipote": "MS0770184"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 160,
                "art_comp": "XMSMM0770172",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770172",
                "art_comp_nipote": "MS0770172"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 166,
                "art_comp": "XMSMM0770174",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770174",
                "art_comp_nipote": "MS0770174"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 166,
                "art_comp": "XMSMM0770183",
                "tipoImpianto": "SEEN 130",
                "stock": "NO",
                "art_comp_figlio": "XMS0770183",
                "art_comp_nipote": "MS0770183"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 175,
                "art_comp": "XMSMM0770176",
                "tipoImpianto": "SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770176",
                "art_comp_nipote": "MS0770176"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 177,
                "art_comp": "XMSMM0770175",
                "tipoImpianto": "SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770175",
                "art_comp_nipote": "MS0770175"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 180,
                "art_comp": "XMSMM0770173",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770173",
                "art_comp_nipote": "MS0770173"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 181,
                "art_comp": "XMSMM0770193",
                "tipoImpianto": "SEEN 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770193",
                "art_comp_nipote": "MS0770193"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 186,
                "art_comp": "XMSMM0770193",
                "tipoImpianto": "SEEN 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770193",
                "art_comp_nipote": "MS0770193"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 190,
                "art_comp": "XMSMM0770192",
                "tipoImpianto": "SEEN 300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770192",
                "art_comp_nipote": "MS0770192"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 215,
                "art_comp": "XMSMM0770176",
                "tipoImpianto": "SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770176",
                "art_comp_nipote": "MS0770176"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 220,
                "art_comp": "XMSMM0770175",
                "tipoImpianto": "SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770175",
                "art_comp_nipote": "MS0770175"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 233,
                "art_comp": "XMSMM0770175",
                "tipoImpianto": "SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770175",
                "art_comp_nipote": "MS0770175"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 242,
                "art_comp": "XMSMM0770191",
                "tipoImpianto": "SEEN 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770191",
                "art_comp_nipote": "MS0770191"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 244,
                "art_comp": "XMSMM0770191",
                "tipoImpianto": "SEEN 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770191",
                "art_comp_nipote": "MS0770191"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 251,
                "art_comp": "XMSMM0770174",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770174",
                "art_comp_nipote": "MS0770174"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 252,
                "art_comp": "XMSMM0770184",
                "tipoImpianto": "SEEN 150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770184",
                "art_comp_nipote": "MS0770184"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 270,
                "art_comp": "XMSMM0770189",
                "tipoImpianto": "SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770189",
                "art_comp_nipote": "MS0770189"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 283,
                "art_comp": "XMSMM0770176",
                "tipoImpianto": "SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770176",
                "art_comp_nipote": "MS0770176"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 285,
                "art_comp": "XMSMM0770176",
                "tipoImpianto": "SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770176",
                "art_comp_nipote": "MS0770176"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 294,
                "art_comp": "XMSMM0770175",
                "tipoImpianto": "SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770175",
                "art_comp_nipote": "MS0770175"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 299,
                "art_comp": "XMSMM0770192",
                "tipoImpianto": "SEEN 300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770192",
                "art_comp_nipote": "MS0770192"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 300,
                "art_comp": "XMSMM0770192",
                "tipoImpianto": "SEEN 300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770192",
                "art_comp_nipote": "MS0770192"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 305,
                "art_comp": "XMSMM0770190",
                "tipoImpianto": "SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770190",
                "art_comp_nipote": "MS0770190"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 310,
                "art_comp": "XMSMM0770193",
                "tipoImpianto": "SEEN 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770193",
                "art_comp_nipote": "MS0770193"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 325,
                "art_comp": "XMSMM0770189",
                "tipoImpianto": "SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770189",
                "art_comp_nipote": "MS0770189"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 352,
                "art_comp": "XMSMM0770176",
                "tipoImpianto": "SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770176",
                "art_comp_nipote": "MS0770176"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 370,
                "art_comp": "XMSMM0770190",
                "tipoImpianto": "SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770190",
                "art_comp_nipote": "MS0770190"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 380,
                "art_comp": "XMSMM0770191",
                "tipoImpianto": "SEEN 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770191",
                "art_comp_nipote": "MS0770191"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 390,
                "art_comp": "XMSMM0770189",
                "tipoImpianto": "SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770189",
                "art_comp_nipote": "MS0770189"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 410,
                "art_comp": "XMSMM0770175",
                "tipoImpianto": "SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770175",
                "art_comp_nipote": "MS0770175"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 410,
                "art_comp": "XMSMM0770189",
                "tipoImpianto": "SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770189",
                "art_comp_nipote": "MS0770189"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 446,
                "art_comp": "XMSMM0770190",
                "tipoImpianto": "SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770190",
                "art_comp_nipote": "MS0770190"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 470,
                "art_comp": "XMSMM0770190",
                "tipoImpianto": "SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770190",
                "art_comp_nipote": "MS0770190"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 485,
                "art_comp": "XMSMM0770176",
                "tipoImpianto": "SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770176",
                "art_comp_nipote": "MS0770176"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 485,
                "art_comp": "XMSMM0770189",
                "tipoImpianto": "SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770189",
                "art_comp_nipote": "MS0770189"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 490,
                "art_comp": "XMSMM0770192",
                "tipoImpianto": "SEEN 300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770192",
                "art_comp_nipote": "MS0770192"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 560,
                "art_comp": "XMSMM0770190",
                "tipoImpianto": "SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770190",
                "art_comp_nipote": "MS0770190"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 665,
                "art_comp": "XMSMM0770189",
                "tipoImpianto": "SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770189",
                "art_comp_nipote": "MS0770189"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 840,
                "art_comp": "XMSMM0770190",
                "tipoImpianto": "SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770190",
                "art_comp_nipote": "MS0770190"
              }
            ],
          'S_CAR':
            [
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 10,
                "art_comp": "XMSMM0770136",
                "tipoImpianto": "SEEN 20 GN18",
                "stock": "NO",
                "art_comp_figlio": "XMS0770136",
                "art_comp_nipote": "MS0770136"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 12,
                "art_comp": "XMSMM0770136",
                "tipoImpianto": "SEEN 20 GN18",
                "stock": "NO",
                "art_comp_figlio": "XMS0770136",
                "art_comp_nipote": "MS0770136"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 14,
                "art_comp": "XMSMM0770136",
                "tipoImpianto": "SEEN 20 GN18",
                "stock": "NO",
                "art_comp_figlio": "XMS0770136",
                "art_comp_nipote": "MS0770136"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 16,
                "art_comp": "XMSMM0770113",
                "tipoImpianto": "SEE 27 GP05",
                "stock": "NO",
                "art_comp_figlio": "XMS0770113",
                "art_comp_nipote": "MS0770113"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 17,
                "art_comp": "XMSMM0770136",
                "tipoImpianto": "SEEN 20 GN18",
                "stock": "NO",
                "art_comp_figlio": "XMS0770136",
                "art_comp_nipote": "MS0770136"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 17,
                "art_comp": "XMSMM0770137",
                "tipoImpianto": "SEEN 35 GN28",
                "stock": "NO",
                "art_comp_figlio": "XMS0770137",
                "art_comp_nipote": "MS0770137"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770138",
                "tipoImpianto": "SEEN 40 GN40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770138",
                "art_comp_nipote": "MS0770138"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770113",
                "tipoImpianto": "SEE 27 GP05",
                "stock": "NO",
                "art_comp_figlio": "XMS0770113",
                "art_comp_nipote": "MS0770113"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 19,
                "art_comp": "XMSMM0770113",
                "tipoImpianto": "SEE 27 GP05",
                "stock": "NO",
                "art_comp_figlio": "XMS0770113",
                "art_comp_nipote": "MS0770113"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 20,
                "art_comp": "XMSMM0770114",
                "tipoImpianto": "SEE38 GP10",
                "stock": "NO",
                "art_comp_figlio": "XMS0770114",
                "art_comp_nipote": "MS0770114"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 21,
                "art_comp": "XMSMM0770137",
                "tipoImpianto": "SEEN 35 GN28",
                "stock": "NO",
                "art_comp_figlio": "XMS0770137",
                "art_comp_nipote": "MS0770137"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 21,
                "art_comp": "XMSMM0770139",
                "tipoImpianto": "SEEN 55 GN41",
                "stock": "NO",
                "art_comp_figlio": "XMS0770139",
                "art_comp_nipote": "MS0770139"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 22,
                "art_comp": "XMSMM0770113",
                "tipoImpianto": "SEE 27 GP05",
                "stock": "NO",
                "art_comp_figlio": "XMS0770113",
                "art_comp_nipote": "MS0770113"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 22,
                "art_comp": "XMSMM0770113",
                "tipoImpianto": "SEE 27 GP05",
                "stock": "NO",
                "art_comp_figlio": "XMS0770113",
                "art_comp_nipote": "MS0770113"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 24,
                "art_comp": "XMSMM0770138",
                "tipoImpianto": "SEEN 40 GN40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770138",
                "art_comp_nipote": "MS0770138"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 24,
                "art_comp": "XMSMM0770114",
                "tipoImpianto": "SEE38 GP10",
                "stock": "NO",
                "art_comp_figlio": "XMS0770114",
                "art_comp_nipote": "MS0770114"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770137",
                "tipoImpianto": "SEEN 35 GN28",
                "stock": "NO",
                "art_comp_figlio": "XMS0770137",
                "art_comp_nipote": "MS0770137"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770114",
                "tipoImpianto": "SEE38 GP10",
                "stock": "NO",
                "art_comp_figlio": "XMS0770114",
                "art_comp_nipote": "MS0770114"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 26,
                "art_comp": "XMSMM0770113",
                "tipoImpianto": "SEE 27 GP05",
                "stock": "NO",
                "art_comp_figlio": "XMS0770113",
                "art_comp_nipote": "MS0770113"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 26,
                "art_comp": "XMSMM0770115",
                "tipoImpianto": "SEE 50 GP15",
                "stock": "NO",
                "art_comp_figlio": "XMS0770115",
                "art_comp_nipote": "MS0770115"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 27,
                "art_comp": "XMSMM0770139",
                "tipoImpianto": "SEEN 55 GN41",
                "stock": "NO",
                "art_comp_figlio": "XMS0770139",
                "art_comp_nipote": "MS0770139"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 28,
                "art_comp": "XMSMM0770138",
                "tipoImpianto": "SEEN 40 GN40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770138",
                "art_comp_nipote": "MS0770138"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 29,
                "art_comp": "XMSMM0770114",
                "tipoImpianto": "SEE38 GP10",
                "stock": "NO",
                "art_comp_figlio": "XMS0770114",
                "art_comp_nipote": "MS0770114"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 29,
                "art_comp": "XMSMM0770114",
                "tipoImpianto": "SEE38 GP10",
                "stock": "NO",
                "art_comp_figlio": "XMS0770114",
                "art_comp_nipote": "MS0770114"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 30,
                "art_comp": "XMSMM0770137",
                "tipoImpianto": "SEEN 35 GN28",
                "stock": "NO",
                "art_comp_figlio": "XMS0770137",
                "art_comp_nipote": "MS0770137"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 31,
                "art_comp": "XMSMM0770139",
                "tipoImpianto": "SEEN 55 GN41",
                "stock": "NO",
                "art_comp_figlio": "XMS0770139",
                "art_comp_nipote": "MS0770139"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 31,
                "art_comp": "XMSMM0770115",
                "tipoImpianto": "SEE 50 GP15",
                "stock": "NO",
                "art_comp_figlio": "XMS0770115",
                "art_comp_nipote": "MS0770115"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 32,
                "art_comp": "XMSMM0770115",
                "tipoImpianto": "SEE 50 GP15",
                "stock": "NO",
                "art_comp_figlio": "XMS0770115",
                "art_comp_nipote": "MS0770115"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 33,
                "art_comp": "XMSMM0770116",
                "tipoImpianto": "SEE 70 GP20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770116",
                "art_comp_nipote": "MS0770116"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770138",
                "tipoImpianto": "SEEN 40 GN40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770138",
                "art_comp_nipote": "MS0770138"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770114",
                "tipoImpianto": "SEE38 GP10",
                "stock": "NO",
                "art_comp_figlio": "XMS0770114",
                "art_comp_nipote": "MS0770114"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 35,
                "art_comp": "XMSMM0770140",
                "tipoImpianto": "SEEN 85 GN50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770140",
                "art_comp_nipote": "MS0770140"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 37,
                "art_comp": "XMSMM0770115",
                "tipoImpianto": "SEE 50 GP15",
                "stock": "NO",
                "art_comp_figlio": "XMS0770115",
                "art_comp_nipote": "MS0770115"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 37,
                "art_comp": "XMSMM0770115",
                "tipoImpianto": "SEE 50 GP15",
                "stock": "NO",
                "art_comp_figlio": "XMS0770115",
                "art_comp_nipote": "MS0770115"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 38,
                "art_comp": "XMSMM0770139",
                "tipoImpianto": "SEEN 55 GN41",
                "stock": "NO",
                "art_comp_figlio": "XMS0770139",
                "art_comp_nipote": "MS0770139"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 38,
                "art_comp": "XMSMM0770140",
                "tipoImpianto": "SEEN 85 GN50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770140",
                "art_comp_nipote": "MS0770140"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 38,
                "art_comp": "XMSMM0770117",
                "tipoImpianto": "SEE 80 GP25",
                "stock": "NO",
                "art_comp_figlio": "XMS0770117",
                "art_comp_nipote": "MS0770117"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 39,
                "art_comp": "XMSMM0770116",
                "tipoImpianto": "SEE 70 GP20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770116",
                "art_comp_nipote": "MS0770116"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 40,
                "art_comp": "XMSMM0770116",
                "tipoImpianto": "SEE 70 GP20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770116",
                "art_comp_nipote": "MS0770116"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 44,
                "art_comp": "XMSMM0770140",
                "tipoImpianto": "SEEN 85 GN50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770140",
                "art_comp_nipote": "MS0770140"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 44,
                "art_comp": "XMSMM0770115",
                "tipoImpianto": "SEE 50 GP15",
                "stock": "NO",
                "art_comp_figlio": "XMS0770115",
                "art_comp_nipote": "MS0770115"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 46,
                "art_comp": "XMSMM0770117",
                "tipoImpianto": "SEE 80 GP25",
                "stock": "NO",
                "art_comp_figlio": "XMS0770117",
                "art_comp_nipote": "MS0770117"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 46,
                "art_comp": "XMSMM0770118",
                "tipoImpianto": "SEE 125 GP30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770118",
                "art_comp_nipote": "MS0770118"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 47,
                "art_comp": "XMSMM0770116",
                "tipoImpianto": "SEE 70 GP20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770116",
                "art_comp_nipote": "MS0770116"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 47,
                "art_comp": "XMSMM0770116",
                "tipoImpianto": "SEE 70 GP20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770116",
                "art_comp_nipote": "MS0770116"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 47,
                "art_comp": "XMSMM0770117",
                "tipoImpianto": "SEE 80 GP25",
                "stock": "NO",
                "art_comp_figlio": "XMS0770117",
                "art_comp_nipote": "MS0770117"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 48,
                "art_comp": "XMSMM0770141",
                "tipoImpianto": "SEEN 95 GN75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770141",
                "art_comp_nipote": "MS0770141"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 54,
                "art_comp": "XMSMM0770117",
                "tipoImpianto": "SEE 80 GP25",
                "stock": "NO",
                "art_comp_figlio": "XMS0770117",
                "art_comp_nipote": "MS0770117"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 54,
                "art_comp": "XMSMM0770117",
                "tipoImpianto": "SEE 80 GP25",
                "stock": "NO",
                "art_comp_figlio": "XMS0770117",
                "art_comp_nipote": "MS0770117"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 55,
                "art_comp": "XMSMM0770116",
                "tipoImpianto": "SEE 70 GP20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770116",
                "art_comp_nipote": "MS0770116"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 58,
                "art_comp": "XMSMM0770118",
                "tipoImpianto": "SEE 125 GP30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770118",
                "art_comp_nipote": "MS0770118"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 59,
                "art_comp": "XMSMM0770119",
                "tipoImpianto": "SEE 135 GP40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770119",
                "art_comp_nipote": "MS0770119"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 62,
                "art_comp": "XMSMM0770140",
                "tipoImpianto": "SEEN 85 GN50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770140",
                "art_comp_nipote": "MS0770140"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 62,
                "art_comp": "XMSMM0770226",
                "tipoImpianto": "SEEN 130 GN76",
                "stock": "NO",
                "art_comp_figlio": "XMS0770226",
                "art_comp_nipote": "MS0770226"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 65,
                "art_comp": "XMSMM0770117",
                "tipoImpianto": "SEE 80 GP25",
                "stock": "NO",
                "art_comp_figlio": "XMS0770117",
                "art_comp_nipote": "MS0770117"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 67,
                "art_comp": "XMSMM0770120",
                "tipoImpianto": "SEE 165 GP47",
                "stock": "NO",
                "art_comp_figlio": "XMS0770120",
                "art_comp_nipote": "MS0770120"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 72,
                "art_comp": "XMSMM0770119",
                "tipoImpianto": "SEE 135 GP40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770119",
                "art_comp_nipote": "MS0770119"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 72,
                "art_comp": "XMSMM0770118",
                "tipoImpianto": "SEE 125 GP30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770118",
                "art_comp_nipote": "MS0770118"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 74,
                "art_comp": "XMSMM0770118",
                "tipoImpianto": "SEE 125 GP30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770118",
                "art_comp_nipote": "MS0770118"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 76,
                "art_comp": "XMSMM0770141",
                "tipoImpianto": "SEEN 95 GN75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770141",
                "art_comp_nipote": "MS0770141"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 78,
                "art_comp": "XMSMM0770141",
                "tipoImpianto": "SEEN 95 GN75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770141",
                "art_comp_nipote": "MS0770141"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 83,
                "art_comp": "XMSMM0770120",
                "tipoImpianto": "SEE 165 GP47",
                "stock": "NO",
                "art_comp_figlio": "XMS0770120",
                "art_comp_nipote": "MS0770120"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 83,
                "art_comp": "XMSMM0770220",
                "tipoImpianto": "SEE 200 GP50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770220",
                "art_comp_nipote": "MS0770220"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 88,
                "art_comp": "XMSMM0770119",
                "tipoImpianto": "SEE 135 GP40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770119",
                "art_comp_nipote": "MS0770119"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 90,
                "art_comp": "XMSMM0770227",
                "tipoImpianto": "SEEN 150 GN100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770227",
                "art_comp_nipote": "MS0770227"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 93,
                "art_comp": "XMSMM0770118",
                "tipoImpianto": "SEE 125 GP30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770118",
                "art_comp_nipote": "MS0770118"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 95,
                "art_comp": "XMSMM0770119",
                "tipoImpianto": "SEE 135 GP40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770119",
                "art_comp_nipote": "MS0770119"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 100,
                "art_comp": "XMSMM0770226",
                "tipoImpianto": "SEEN 130 GN76",
                "stock": "NO",
                "art_comp_figlio": "XMS0770226",
                "art_comp_nipote": "MS0770226"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 101,
                "art_comp": "XMSMM0770226",
                "tipoImpianto": "SEEN 130 GN76",
                "stock": "NO",
                "art_comp_figlio": "XMS0770226",
                "art_comp_nipote": "MS0770226"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 103,
                "art_comp": "XMSMM0770220",
                "tipoImpianto": "SEE 200 GP50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770220",
                "art_comp_nipote": "MS0770220"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 104,
                "art_comp": "XMSMM0770120",
                "tipoImpianto": "SEE 165 GP47",
                "stock": "NO",
                "art_comp_figlio": "XMS0770120",
                "art_comp_nipote": "MS0770120"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 106,
                "art_comp": "XMSMM0770120",
                "tipoImpianto": "SEE 165 GP47",
                "stock": "NO",
                "art_comp_figlio": "XMS0770120",
                "art_comp_nipote": "MS0770120"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 110,
                "art_comp": "XMSMM0770228",
                "tipoImpianto": "SEEN 200 GN200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770228",
                "art_comp_nipote": "MS0770228"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 118,
                "art_comp": "XMSMM0770119",
                "tipoImpianto": "SEE 135 GP40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770119",
                "art_comp_nipote": "MS0770119"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 128,
                "art_comp": "XMSMM0770118",
                "tipoImpianto": "SEE 125 GP30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770118",
                "art_comp_nipote": "MS0770118"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 130,
                "art_comp": "XMSMM0770220",
                "tipoImpianto": "SEE 200 GP50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770220",
                "art_comp_nipote": "MS0770220"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 131,
                "art_comp": "XMSMM0770220",
                "tipoImpianto": "SEE 200 GP50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770220",
                "art_comp_nipote": "MS0770220"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 133,
                "art_comp": "XMSMM0770141",
                "tipoImpianto": "SEEN 95 GN75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770141",
                "art_comp_nipote": "MS0770141"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 133,
                "art_comp": "XMSMM0770120",
                "tipoImpianto": "SEE 165 GP47",
                "stock": "NO",
                "art_comp_figlio": "XMS0770120",
                "art_comp_nipote": "MS0770120"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 145,
                "art_comp": "XMSMM0770221",
                "tipoImpianto": "SEE 260 GP75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770221",
                "art_comp_nipote": "MS0770221"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 147,
                "art_comp": "XMSMM0770227",
                "tipoImpianto": "SEEN 150 GN100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770227",
                "art_comp_nipote": "MS0770227"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 152,
                "art_comp": "XMSMM0770229",
                "tipoImpianto": "SEEN 260 GN150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770229",
                "art_comp_nipote": "MS0770229"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 154,
                "art_comp": "XMSMM0770227",
                "tipoImpianto": "SEEN 150 GN100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770227",
                "art_comp_nipote": "MS0770227"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 160,
                "art_comp": "XMSMM0770119",
                "tipoImpianto": "SEE 135 GP40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770119",
                "art_comp_nipote": "MS0770119"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 166,
                "art_comp": "XMSMM0770226",
                "tipoImpianto": "SEEN 130 GN76",
                "stock": "NO",
                "art_comp_figlio": "XMS0770226",
                "art_comp_nipote": "MS0770226"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 166,
                "art_comp": "XMSMM0770220",
                "tipoImpianto": "SEE 200 GP50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770220",
                "art_comp_nipote": "MS0770220"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 175,
                "art_comp": "XMSMM0770222",
                "tipoImpianto": "SEE 320 GP100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770222",
                "art_comp_nipote": "MS0770222"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 177,
                "art_comp": "XMSMM0770221",
                "tipoImpianto": "SEE 260 GP75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770221",
                "art_comp_nipote": "MS0770221"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 180,
                "art_comp": "XMSMM0770120",
                "tipoImpianto": "SEE 165 GP47",
                "stock": "NO",
                "art_comp_figlio": "XMS0770120",
                "art_comp_nipote": "MS0770120"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 181,
                "art_comp": "XMSMM0770228",
                "tipoImpianto": "SEEN 200 GN200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770228",
                "art_comp_nipote": "MS0770228"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 186,
                "art_comp": "XMSMM0770228",
                "tipoImpianto": "SEEN 200 GN200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770228",
                "art_comp_nipote": "MS0770228"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 190,
                "art_comp": "XMSMM0770230",
                "tipoImpianto": "SEEN 300 GN300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770230",
                "art_comp_nipote": "MS0770230"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 215,
                "art_comp": "XMSMM0770222",
                "tipoImpianto": "SEE 320 GP100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770222",
                "art_comp_nipote": "MS0770222"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 220,
                "art_comp": "XMSMM0770221",
                "tipoImpianto": "SEE 260 GP75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770221",
                "art_comp_nipote": "MS0770221"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 233,
                "art_comp": "XMSMM0770221",
                "tipoImpianto": "SEE 260 GP75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770221",
                "art_comp_nipote": "MS0770221"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 242,
                "art_comp": "XMSMM0770229",
                "tipoImpianto": "SEEN 260 GN150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770229",
                "art_comp_nipote": "MS0770229"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 244,
                "art_comp": "XMSMM0770229",
                "tipoImpianto": "SEEN 260 GN150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770229",
                "art_comp_nipote": "MS0770229"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 251,
                "art_comp": "XMSMM0770220",
                "tipoImpianto": "SEE 200 GP50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770220",
                "art_comp_nipote": "MS0770220"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 252,
                "art_comp": "XMSMM0770227",
                "tipoImpianto": "SEEN 150 GN100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770227",
                "art_comp_nipote": "MS0770227"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 270,
                "art_comp": "XMSMM0770223",
                "tipoImpianto": "SEE450 GP150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770223",
                "art_comp_nipote": "MS0770223"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 283,
                "art_comp": "XMSMM0770222",
                "tipoImpianto": "SEE 320 GP100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770222",
                "art_comp_nipote": "MS0770222"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 285,
                "art_comp": "XMSMM0770222",
                "tipoImpianto": "SEE 320 GP100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770222",
                "art_comp_nipote": "MS0770222"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 294,
                "art_comp": "XMSMM0770221",
                "tipoImpianto": "SEE 260 GP75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770221",
                "art_comp_nipote": "MS0770221"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 299,
                "art_comp": "XMSMM0770230",
                "tipoImpianto": "SEEN 300 GN300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770230",
                "art_comp_nipote": "MS0770230"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 300,
                "art_comp": "XMSMM0770230",
                "tipoImpianto": "SEEN 300 GN300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770230",
                "art_comp_nipote": "MS0770230"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 305,
                "art_comp": "XMSMM0770224",
                "tipoImpianto": "SEE 550 GP200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770224",
                "art_comp_nipote": "MS0770224"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 310,
                "art_comp": "XMSMM0770228",
                "tipoImpianto": "SEEN 200 GN200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770228",
                "art_comp_nipote": "MS0770228"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 325,
                "art_comp": "XMSMM0770223",
                "tipoImpianto": "SEE450 GP150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770223",
                "art_comp_nipote": "MS0770223"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 352,
                "art_comp": "XMSMM0770222",
                "tipoImpianto": "SEE 320 GP100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770222",
                "art_comp_nipote": "MS0770222"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 370,
                "art_comp": "XMSMM0770224",
                "tipoImpianto": "SEE 550 GP200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770224",
                "art_comp_nipote": "MS0770224"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 380,
                "art_comp": "XMSMM0770229",
                "tipoImpianto": "SEEN 260 GN150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770229",
                "art_comp_nipote": "MS0770229"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 390,
                "art_comp": "XMSMM0770223",
                "tipoImpianto": "SEE450 GP150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770223",
                "art_comp_nipote": "MS0770223"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 410,
                "art_comp": "XMSMM0770221",
                "tipoImpianto": "SEE 260 GP75",
                "stock": "NO",
                "art_comp_figlio": "XMS0770221",
                "art_comp_nipote": "MS0770221"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 410,
                "art_comp": "XMSMM0770223",
                "tipoImpianto": "SEE450 GP150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770223",
                "art_comp_nipote": "MS0770223"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 446,
                "art_comp": "XMSMM0770224",
                "tipoImpianto": "SEE 550 GP200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770224",
                "art_comp_nipote": "MS0770224"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 470,
                "art_comp": "XMSMM0770224",
                "tipoImpianto": "SEE 550 GP200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770224",
                "art_comp_nipote": "MS0770224"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 485,
                "art_comp": "XMSMM0770223",
                "tipoImpianto": "SEE450 GP150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770223",
                "art_comp_nipote": "MS0770223"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 485,
                "art_comp": "XMSMM0770222",
                "tipoImpianto": "SEE 320 GP100",
                "stock": "NO",
                "art_comp_figlio": "XMS0770222",
                "art_comp_nipote": "MS0770222"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 490,
                "art_comp": "XMSMM0770230",
                "tipoImpianto": "SEEN 300 GN300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770230",
                "art_comp_nipote": "MS0770230"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 560,
                "art_comp": "XMSMM0770224",
                "tipoImpianto": "SEE 550 GP200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770224",
                "art_comp_nipote": "MS0770224"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 665,
                "art_comp": "XMSMM0770223",
                "tipoImpianto": "SEE450 GP150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770223",
                "art_comp_nipote": "MS0770223"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 840,
                "art_comp": "XMSMM0770224",
                "tipoImpianto": "SEE 550 GP200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770224",
                "art_comp_nipote": "MS0770224"
              }
            ],
          'SEE':
            [
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 10,
                "art_comp": "XMSMM0770051",
                "tipoImpianto": "GN 18 SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770051",
                "art_comp_nipote": "MS0770051"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 12,
                "art_comp": "XMSMM0770051",
                "tipoImpianto": "GN 18 SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770051",
                "art_comp_nipote": "MS0770051"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 14,
                "art_comp": "XMSMM0770051",
                "tipoImpianto": "GN 18 SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770051",
                "art_comp_nipote": "MS0770051"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 16,
                "art_comp": "XMSMM0770031",
                "tipoImpianto": "GP 05 SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770031",
                "art_comp_nipote": "MS0770031"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 17,
                "art_comp": "XMSMM0770051",
                "tipoImpianto": "GN 18 SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770051",
                "art_comp_nipote": "MS0770051"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 17,
                "art_comp": "XMSMM0770052",
                "tipoImpianto": "GN 28 SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770052",
                "art_comp_nipote": "MS0770052"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770053",
                "tipoImpianto": "GN 40 SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770053",
                "art_comp_nipote": "MS0770053"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770031",
                "tipoImpianto": "GP 05 SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770031",
                "art_comp_nipote": "MS0770031"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 19,
                "art_comp": "XMSMM0770031",
                "tipoImpianto": "GP 05 SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770031",
                "art_comp_nipote": "MS0770031"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 20,
                "art_comp": "XMSMM0770032",
                "tipoImpianto": "GP 10 SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770032",
                "art_comp_nipote": "MS0770032"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 21,
                "art_comp": "XMSMM0770052",
                "tipoImpianto": "GN 28 SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770052",
                "art_comp_nipote": "MS0770052"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 21,
                "art_comp": "XMSMM0770054",
                "tipoImpianto": "GN 41 SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770054",
                "art_comp_nipote": "MS0770054"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 22,
                "art_comp": "XMSMM0770031",
                "tipoImpianto": "GP 05 SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770031",
                "art_comp_nipote": "MS0770031"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 22,
                "art_comp": "XMSMM0770031",
                "tipoImpianto": "GP 05 SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770031",
                "art_comp_nipote": "MS0770031"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 24,
                "art_comp": "XMSMM0770053",
                "tipoImpianto": "GN 40 SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770053",
                "art_comp_nipote": "MS0770053"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 24,
                "art_comp": "XMSMM0770032",
                "tipoImpianto": "GP 10 SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770032",
                "art_comp_nipote": "MS0770032"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770052",
                "tipoImpianto": "GN 28 SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770052",
                "art_comp_nipote": "MS0770052"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770032",
                "tipoImpianto": "GP 10 SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770032",
                "art_comp_nipote": "MS0770032"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 26,
                "art_comp": "XMSMM0770031",
                "tipoImpianto": "GP 05 SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770031",
                "art_comp_nipote": "MS0770031"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 26,
                "art_comp": "XMSMM0770033",
                "tipoImpianto": "GP 15 SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770033",
                "art_comp_nipote": "MS0770033"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 27,
                "art_comp": "XMSMM0770054",
                "tipoImpianto": "GN 41 SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770054",
                "art_comp_nipote": "MS0770054"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 28,
                "art_comp": "XMSMM0770053",
                "tipoImpianto": "GN 40 SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770053",
                "art_comp_nipote": "MS0770053"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 29,
                "art_comp": "XMSMM0770032",
                "tipoImpianto": "GP 10 SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770032",
                "art_comp_nipote": "MS0770032"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 29,
                "art_comp": "XMSMM0770032",
                "tipoImpianto": "GP 10 SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770032",
                "art_comp_nipote": "MS0770032"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 30,
                "art_comp": "XMSMM0770052",
                "tipoImpianto": "GN 28 SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770052",
                "art_comp_nipote": "MS0770052"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 31,
                "art_comp": "XMSMM0770054",
                "tipoImpianto": "GN 41 SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770054",
                "art_comp_nipote": "MS0770054"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 31,
                "art_comp": "XMSMM0770033",
                "tipoImpianto": "GP 15 SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770033",
                "art_comp_nipote": "MS0770033"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 32,
                "art_comp": "XMSMM0770033",
                "tipoImpianto": "GP 15 SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770033",
                "art_comp_nipote": "MS0770033"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 33,
                "art_comp": "XMSMM0770034",
                "tipoImpianto": "GP 20 SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770034",
                "art_comp_nipote": "MS0770034"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770053",
                "tipoImpianto": "GN 40 SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770053",
                "art_comp_nipote": "MS0770053"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770032",
                "tipoImpianto": "GP 10 SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770032",
                "art_comp_nipote": "MS0770032"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 35,
                "art_comp": "XMSMM0770055",
                "tipoImpianto": "GN 50 SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770055",
                "art_comp_nipote": "MS0770055"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 37,
                "art_comp": "XMSMM0770033",
                "tipoImpianto": "GP 15 SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770033",
                "art_comp_nipote": "MS0770033"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 37,
                "art_comp": "XMSMM0770033",
                "tipoImpianto": "GP 15 SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770033",
                "art_comp_nipote": "MS0770033"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 38,
                "art_comp": "XMSMM0770054",
                "tipoImpianto": "GN 41 SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770054",
                "art_comp_nipote": "MS0770054"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 38,
                "art_comp": "XMSMM0770055",
                "tipoImpianto": "GN 50 SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770055",
                "art_comp_nipote": "MS0770055"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 38,
                "art_comp": "XMSMM0770035",
                "tipoImpianto": "GP 25 SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770035",
                "art_comp_nipote": "MS0770035"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 39,
                "art_comp": "XMSMM0770034",
                "tipoImpianto": "GP 20 SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770034",
                "art_comp_nipote": "MS0770034"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 40,
                "art_comp": "XMSMM0770034",
                "tipoImpianto": "GP 20 SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770034",
                "art_comp_nipote": "MS0770034"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 44,
                "art_comp": "XMSMM0770055",
                "tipoImpianto": "GN 50 SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770055",
                "art_comp_nipote": "MS0770055"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 44,
                "art_comp": "XMSMM0770033",
                "tipoImpianto": "GP 15 SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770033",
                "art_comp_nipote": "MS0770033"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 46,
                "art_comp": "XMSMM0770035",
                "tipoImpianto": "GP 25 SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770035",
                "art_comp_nipote": "MS0770035"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 46,
                "art_comp": "XMSMM0770036",
                "tipoImpianto": "GP 30 SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770036",
                "art_comp_nipote": "MS0770036"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 47,
                "art_comp": "XMSMM0770034",
                "tipoImpianto": "GP 20 SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770034",
                "art_comp_nipote": "MS0770034"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 47,
                "art_comp": "XMSMM0770034",
                "tipoImpianto": "GP 20 SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770034",
                "art_comp_nipote": "MS0770034"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 47,
                "art_comp": "XMSMM0770035",
                "tipoImpianto": "GP 25 SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770035",
                "art_comp_nipote": "MS0770035"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 48,
                "art_comp": "XMSMM0770056",
                "tipoImpianto": "GN 75SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770056",
                "art_comp_nipote": "MS0770056"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 54,
                "art_comp": "XMSMM0770035",
                "tipoImpianto": "GP 25 SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770035",
                "art_comp_nipote": "MS0770035"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 54,
                "art_comp": "XMSMM0770035",
                "tipoImpianto": "GP 25 SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770035",
                "art_comp_nipote": "MS0770035"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 55,
                "art_comp": "XMSMM0770034",
                "tipoImpianto": "GP 20 SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770034",
                "art_comp_nipote": "MS0770034"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 58,
                "art_comp": "XMSMM0770036",
                "tipoImpianto": "GP 30 SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770036",
                "art_comp_nipote": "MS0770036"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 59,
                "art_comp": "XMSMM0770037",
                "tipoImpianto": "GP 40 SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770037",
                "art_comp_nipote": "MS0770037"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 62,
                "art_comp": "XMSMM0770055",
                "tipoImpianto": "GN 50 SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770055",
                "art_comp_nipote": "MS0770055"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 62,
                "art_comp": "XMSMM0770058",
                "tipoImpianto": "GN 76 SEEN 130",
                "stock": "NO",
                "art_comp_figlio": "XMS0770058",
                "art_comp_nipote": "MS0770058"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 65,
                "art_comp": "XMSMM0770035",
                "tipoImpianto": "GP 25 SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770035",
                "art_comp_nipote": "MS0770035"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 67,
                "art_comp": "XMSMM0770038",
                "tipoImpianto": "GP 47 SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770038",
                "art_comp_nipote": "MS0770038"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 72,
                "art_comp": "XMSMM0770037",
                "tipoImpianto": "GP 40 SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770037",
                "art_comp_nipote": "MS0770037"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 72,
                "art_comp": "XMSMM0770036",
                "tipoImpianto": "GP 30 SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770036",
                "art_comp_nipote": "MS0770036"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 74,
                "art_comp": "XMSMM0770036",
                "tipoImpianto": "GP 30 SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770036",
                "art_comp_nipote": "MS0770036"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 76,
                "art_comp": "XMSMM0770056",
                "tipoImpianto": "GN 75SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770056",
                "art_comp_nipote": "MS0770056"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 78,
                "art_comp": "XMSMM0770056",
                "tipoImpianto": "GN 75SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770056",
                "art_comp_nipote": "MS0770056"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 83,
                "art_comp": "XMSMM0770038",
                "tipoImpianto": "GP 47 SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770038",
                "art_comp_nipote": "MS0770038"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 83,
                "art_comp": "XMSMM0770039",
                "tipoImpianto": "GP 50 SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770039",
                "art_comp_nipote": "MS0770039"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 88,
                "art_comp": "XMSMM0770037",
                "tipoImpianto": "GP 40 SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770037",
                "art_comp_nipote": "MS0770037"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 90,
                "art_comp": "XMSMM0770057",
                "tipoImpianto": "GN100 SEEN 150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770057",
                "art_comp_nipote": "MS0770057"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 93,
                "art_comp": "XMSMM0770036",
                "tipoImpianto": "GP 30 SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770036",
                "art_comp_nipote": "MS0770036"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 95,
                "art_comp": "XMSMM0770037",
                "tipoImpianto": "GP 40 SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770037",
                "art_comp_nipote": "MS0770037"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 100,
                "art_comp": "XMSMM0770058",
                "tipoImpianto": "GN 76 SEEN 130",
                "stock": "NO",
                "art_comp_figlio": "XMS0770058",
                "art_comp_nipote": "MS0770058"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 101,
                "art_comp": "XMSMM0770058",
                "tipoImpianto": "GN 76 SEEN 130",
                "stock": "NO",
                "art_comp_figlio": "XMS0770058",
                "art_comp_nipote": "MS0770058"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 103,
                "art_comp": "XMSMM0770039",
                "tipoImpianto": "GP 50 SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770039",
                "art_comp_nipote": "MS0770039"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 104,
                "art_comp": "XMSMM0770038",
                "tipoImpianto": "GP 47 SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770038",
                "art_comp_nipote": "MS0770038"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 106,
                "art_comp": "XMSMM0770038",
                "tipoImpianto": "GP 47 SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770038",
                "art_comp_nipote": "MS0770038"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 110,
                "art_comp": "XMSMM0770047",
                "tipoImpianto": "GN200 SEEN 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770047",
                "art_comp_nipote": "MS0770047"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 118,
                "art_comp": "XMSMM0770037",
                "tipoImpianto": "GP 40 SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770037",
                "art_comp_nipote": "MS0770037"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 128,
                "art_comp": "XMSMM0770036",
                "tipoImpianto": "GP 30 SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770036",
                "art_comp_nipote": "MS0770036"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 130,
                "art_comp": "XMSMM0770039",
                "tipoImpianto": "GP 50 SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770039",
                "art_comp_nipote": "MS0770039"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 131,
                "art_comp": "XMSMM0770039",
                "tipoImpianto": "GP 50 SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770039",
                "art_comp_nipote": "MS0770039"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 133,
                "art_comp": "XMSMM0770056",
                "tipoImpianto": "GN 75SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770056",
                "art_comp_nipote": "MS0770056"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 133,
                "art_comp": "XMSMM0770038",
                "tipoImpianto": "GP 47 SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770038",
                "art_comp_nipote": "MS0770038"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 145,
                "art_comp": "XMSMM0770040",
                "tipoImpianto": "GP 75 SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770040",
                "art_comp_nipote": "MS0770040"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 147,
                "art_comp": "XMSMM0770057",
                "tipoImpianto": "GN100 SEEN 150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770057",
                "art_comp_nipote": "MS0770057"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 152,
                "art_comp": "XMSMM0770048",
                "tipoImpianto": "GN150 SEEN 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770048",
                "art_comp_nipote": "MS0770048"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 154,
                "art_comp": "XMSMM0770057",
                "tipoImpianto": "GN100 SEEN 150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770057",
                "art_comp_nipote": "MS0770057"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 160,
                "art_comp": "XMSMM0770037",
                "tipoImpianto": "GP 40 SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770037",
                "art_comp_nipote": "MS0770037"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 166,
                "art_comp": "XMSMM0770058",
                "tipoImpianto": "GN 76 SEEN 130",
                "stock": "NO",
                "art_comp_figlio": "XMS0770058",
                "art_comp_nipote": "MS0770058"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 166,
                "art_comp": "XMSMM0770039",
                "tipoImpianto": "GP 50 SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770039",
                "art_comp_nipote": "MS0770039"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 175,
                "art_comp": "XMSMM0770041",
                "tipoImpianto": "GP100 SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770041",
                "art_comp_nipote": "MS0770041"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 177,
                "art_comp": "XMSMM0770040",
                "tipoImpianto": "GP 75 SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770040",
                "art_comp_nipote": "MS0770040"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 180,
                "art_comp": "XMSMM0770038",
                "tipoImpianto": "GP 47 SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770038",
                "art_comp_nipote": "MS0770038"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 181,
                "art_comp": "XMSMM0770047",
                "tipoImpianto": "GN200 SEEN 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770047",
                "art_comp_nipote": "MS0770047"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 186,
                "art_comp": "XMSMM0770047",
                "tipoImpianto": "GN200 SEEN 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770047",
                "art_comp_nipote": "MS0770047"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 190,
                "art_comp": "XMSMM0770049",
                "tipoImpianto": "GN300 SEEN 300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770049",
                "art_comp_nipote": "MS0770049"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 215,
                "art_comp": "XMSMM0770041",
                "tipoImpianto": "GP100 SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770041",
                "art_comp_nipote": "MS0770041"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 220,
                "art_comp": "XMSMM0770040",
                "tipoImpianto": "GP 75 SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770040",
                "art_comp_nipote": "MS0770040"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 233,
                "art_comp": "XMSMM0770040",
                "tipoImpianto": "GP 75 SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770040",
                "art_comp_nipote": "MS0770040"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 242,
                "art_comp": "XMSMM0770048",
                "tipoImpianto": "GN150 SEEN 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770048",
                "art_comp_nipote": "MS0770048"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 244,
                "art_comp": "XMSMM0770048",
                "tipoImpianto": "GN150 SEEN 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770048",
                "art_comp_nipote": "MS0770048"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 251,
                "art_comp": "XMSMM0770039",
                "tipoImpianto": "GP 50 SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770039",
                "art_comp_nipote": "MS0770039"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 252,
                "art_comp": "XMSMM0770057",
                "tipoImpianto": "GN100 SEEN 150",
                "stock": "NO",
                "art_comp_figlio": "XMS0770057",
                "art_comp_nipote": "MS0770057"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 270,
                "art_comp": "XMSMM0770045",
                "tipoImpianto": "GP150 SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770045",
                "art_comp_nipote": "MS0770045"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 283,
                "art_comp": "XMSMM0770041",
                "tipoImpianto": "GP100 SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770041",
                "art_comp_nipote": "MS0770041"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 285,
                "art_comp": "XMSMM0770041",
                "tipoImpianto": "GP100 SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770041",
                "art_comp_nipote": "MS0770041"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 294,
                "art_comp": "XMSMM0770040",
                "tipoImpianto": "GP 75 SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770040",
                "art_comp_nipote": "MS0770040"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 299,
                "art_comp": "XMSMM0770049",
                "tipoImpianto": "GN300 SEEN 300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770049",
                "art_comp_nipote": "MS0770049"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 300,
                "art_comp": "XMSMM0770049",
                "tipoImpianto": "GN300 SEEN 300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770049",
                "art_comp_nipote": "MS0770049"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 305,
                "art_comp": "XMSMM0770046",
                "tipoImpianto": "GP200 SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770046",
                "art_comp_nipote": "MS0770046"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 310,
                "art_comp": "XMSMM0770047",
                "tipoImpianto": "GN200 SEEN 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770047",
                "art_comp_nipote": "MS0770047"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 325,
                "art_comp": "XMSMM0770045",
                "tipoImpianto": "GP150 SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770045",
                "art_comp_nipote": "MS0770045"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 352,
                "art_comp": "XMSMM0770041",
                "tipoImpianto": "GP100 SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770041",
                "art_comp_nipote": "MS0770041"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 370,
                "art_comp": "XMSMM0770046",
                "tipoImpianto": "GP200 SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770046",
                "art_comp_nipote": "MS0770046"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 380,
                "art_comp": "XMSMM0770048",
                "tipoImpianto": "GN150 SEEN 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770048",
                "art_comp_nipote": "MS0770048"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 390,
                "art_comp": "XMSMM0770045",
                "tipoImpianto": "GP150 SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770045",
                "art_comp_nipote": "MS0770045"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 410,
                "art_comp": "XMSMM0770040",
                "tipoImpianto": "GP 75 SEE 260",
                "stock": "NO",
                "art_comp_figlio": "XMS0770040",
                "art_comp_nipote": "MS0770040"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 410,
                "art_comp": "XMSMM0770045",
                "tipoImpianto": "GP150 SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770045",
                "art_comp_nipote": "MS0770045"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 446,
                "art_comp": "XMSMM0770046",
                "tipoImpianto": "GP200 SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770046",
                "art_comp_nipote": "MS0770046"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 470,
                "art_comp": "XMSMM0770046",
                "tipoImpianto": "GP200 SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770046",
                "art_comp_nipote": "MS0770046"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 485,
                "art_comp": "XMSMM0770045",
                "tipoImpianto": "GP150 SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770045",
                "art_comp_nipote": "MS0770045"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 485,
                "art_comp": "XMSMM0770041",
                "tipoImpianto": "GP100 SEE 320",
                "stock": "NO",
                "art_comp_figlio": "XMS0770041",
                "art_comp_nipote": "MS0770041"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 490,
                "art_comp": "XMSMM0770049",
                "tipoImpianto": "GN300 SEEN 300",
                "stock": "NO",
                "art_comp_figlio": "XMS0770049",
                "art_comp_nipote": "MS0770049"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 560,
                "art_comp": "XMSMM0770046",
                "tipoImpianto": "GP200 SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770046",
                "art_comp_nipote": "MS0770046"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 665,
                "art_comp": "XMSMM0770045",
                "tipoImpianto": "GP150 SEE 450",
                "stock": "NO",
                "art_comp_figlio": "XMS0770045",
                "art_comp_nipote": "MS0770045"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 840,
                "art_comp": "XMSMM0770046",
                "tipoImpianto": "GP200 SEE 550",
                "stock": "NO",
                "art_comp_figlio": "XMS0770046",
                "art_comp_nipote": "MS0770046"
              }
            ],          
          'SEEW':
            [
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 10,
                "art_comp": "XMSMM0770066",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770066",
                "art_comp_nipote": "MS0770066"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 12,
                "art_comp": "XMSMM0770066",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770066",
                "art_comp_nipote": "MS0770066"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 14,
                "art_comp": "XMSMM0770066",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770066",
                "art_comp_nipote": "MS0770066"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 16,
                "art_comp": "XMSMM0770072",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770072",
                "art_comp_nipote": "MS0770072"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 17,
                "art_comp": "XMSMM0770066",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XMS0770066",
                "art_comp_nipote": "MS0770066"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 17,
                "art_comp": "XMSMM0770067",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770067",
                "art_comp_nipote": "MS0770067"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770068",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770068",
                "art_comp_nipote": "MS0770068"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770072",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770072",
                "art_comp_nipote": "MS0770072"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 19,
                "art_comp": "XMSMM0770072",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770072",
                "art_comp_nipote": "MS0770072"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 20,
                "art_comp": "XMSMM0770059",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770059",
                "art_comp_nipote": "MS0770059"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 21,
                "art_comp": "XMSMM0770067",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770067",
                "art_comp_nipote": "MS0770067"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 21,
                "art_comp": "XMSMM0770069",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770069",
                "art_comp_nipote": "MS0770069"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 22,
                "art_comp": "XMSMM0770072",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770072",
                "art_comp_nipote": "MS0770072"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 22,
                "art_comp": "XMSMM0770072",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770072",
                "art_comp_nipote": "MS0770072"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 24,
                "art_comp": "XMSMM0770059",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770059",
                "art_comp_nipote": "MS0770059"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 24,
                "art_comp": "XMSMM0770068",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770068",
                "art_comp_nipote": "MS0770068"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770059",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770059",
                "art_comp_nipote": "MS0770059"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770067",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770067",
                "art_comp_nipote": "MS0770067"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 26,
                "art_comp": "XMSMM0770060",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770060",
                "art_comp_nipote": "MS0770060"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 26,
                "art_comp": "XMSMM0770072",
                "tipoImpianto": "SEE 27",
                "stock": "NO",
                "art_comp_figlio": "XMS0770072",
                "art_comp_nipote": "MS0770072"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 27,
                "art_comp": "XMSMM0770069",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770069",
                "art_comp_nipote": "MS0770069"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 28,
                "art_comp": "XMSMM0770068",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770068",
                "art_comp_nipote": "MS0770068"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 29,
                "art_comp": "XMSMM0770059",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770059",
                "art_comp_nipote": "MS0770059"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 29,
                "art_comp": "XMSMM0770059",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770059",
                "art_comp_nipote": "MS0770059"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 30,
                "art_comp": "XMSMM0770067",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770067",
                "art_comp_nipote": "MS0770067"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 31,
                "art_comp": "XMSMM0770060",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770060",
                "art_comp_nipote": "MS0770060"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 31,
                "art_comp": "XMSMM0770069",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770069",
                "art_comp_nipote": "MS0770069"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 32,
                "art_comp": "XMSMM0770060",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770060",
                "art_comp_nipote": "MS0770060"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 33,
                "art_comp": "XMSMM0770061",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770061",
                "art_comp_nipote": "MS0770061"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770059",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XMS0770059",
                "art_comp_nipote": "MS0770059"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770068",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770068",
                "art_comp_nipote": "MS0770068"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 35,
                "art_comp": "XMSMM0770070",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770070",
                "art_comp_nipote": "MS0770070"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 37,
                "art_comp": "XMSMM0770060",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770060",
                "art_comp_nipote": "MS0770060"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 37,
                "art_comp": "XMSMM0770060",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770060",
                "art_comp_nipote": "MS0770060"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 38,
                "art_comp": "XMSMM0770062",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770062",
                "art_comp_nipote": "MS0770062"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 38,
                "art_comp": "XMSMM0770069",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770069",
                "art_comp_nipote": "MS0770069"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 38,
                "art_comp": "XMSMM0770070",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770070",
                "art_comp_nipote": "MS0770070"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 39,
                "art_comp": "XMSMM0770061",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770061",
                "art_comp_nipote": "MS0770061"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 40,
                "art_comp": "XMSMM0770061",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770061",
                "art_comp_nipote": "MS0770061"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 44,
                "art_comp": "XMSMM0770060",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770060",
                "art_comp_nipote": "MS0770060"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 44,
                "art_comp": "XMSMM0770070",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770070",
                "art_comp_nipote": "MS0770070"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 46,
                "art_comp": "XMSMM0770062",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770062",
                "art_comp_nipote": "MS0770062"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 46,
                "art_comp": "XMSMM0770063",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770063",
                "art_comp_nipote": "MS0770063"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 47,
                "art_comp": "XMSMM0770061",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770061",
                "art_comp_nipote": "MS0770061"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 47,
                "art_comp": "XMSMM0770061",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770061",
                "art_comp_nipote": "MS0770061"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 47,
                "art_comp": "XMSMM0770062",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770062",
                "art_comp_nipote": "MS0770062"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 48,
                "art_comp": "XMSMM0770071",
                "tipoImpianto": "SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770071",
                "art_comp_nipote": "MS0770071"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 54,
                "art_comp": "XMSMM0770062",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770062",
                "art_comp_nipote": "MS0770062"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 54,
                "art_comp": "XMSMM0770062",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770062",
                "art_comp_nipote": "MS0770062"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 55,
                "art_comp": "XMSMM0770061",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770061",
                "art_comp_nipote": "MS0770061"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 58,
                "art_comp": "XMSMM0770063",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770063",
                "art_comp_nipote": "MS0770063"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 59,
                "art_comp": "XMSMM0770064",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770064",
                "art_comp_nipote": "MS0770064"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 62,
                "art_comp": "XMSMM0770070",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770070",
                "art_comp_nipote": "MS0770070"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 65,
                "art_comp": "XMSMM0770062",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770062",
                "art_comp_nipote": "MS0770062"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 67,
                "art_comp": "XMSMM0770065",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770065",
                "art_comp_nipote": "MS0770065"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 72,
                "art_comp": "XMSMM0770063",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770063",
                "art_comp_nipote": "MS0770063"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 72,
                "art_comp": "XMSMM0770064",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770064",
                "art_comp_nipote": "MS0770064"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 74,
                "art_comp": "XMSMM0770063",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770063",
                "art_comp_nipote": "MS0770063"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 76,
                "art_comp": "XMSMM0770071",
                "tipoImpianto": "SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770071",
                "art_comp_nipote": "MS0770071"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 78,
                "art_comp": "XMSMM0770071",
                "tipoImpianto": "SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770071",
                "art_comp_nipote": "MS0770071"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 83,
                "art_comp": "XMSMM0770065",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770065",
                "art_comp_nipote": "MS0770065"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 88,
                "art_comp": "XMSMM0770064",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770064",
                "art_comp_nipote": "MS0770064"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 93,
                "art_comp": "XMSMM0770063",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770063",
                "art_comp_nipote": "MS0770063"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 95,
                "art_comp": "XMSMM0770064",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770064",
                "art_comp_nipote": "MS0770064"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 104,
                "art_comp": "XMSMM0770065",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770065",
                "art_comp_nipote": "MS0770065"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 106,
                "art_comp": "XMSMM0770065",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770065",
                "art_comp_nipote": "MS0770065"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 118,
                "art_comp": "XMSMM0770064",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770064",
                "art_comp_nipote": "MS0770064"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 128,
                "art_comp": "XMSMM0770063",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770063",
                "art_comp_nipote": "MS0770063"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 133,
                "art_comp": "XMSMM0770065",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770065",
                "art_comp_nipote": "MS0770065"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 133,
                "art_comp": "XMSMM0770071",
                "tipoImpianto": "SEEN 95",
                "stock": "NO",
                "art_comp_figlio": "XMS0770071",
                "art_comp_nipote": "MS0770071"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 160,
                "art_comp": "XMSMM0770064",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770064",
                "art_comp_nipote": "MS0770064"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 180,
                "art_comp": "XMSMM0770065",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770065",
                "art_comp_nipote": "MS0770065"
              }
            ],
          'SILENT':
            [
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 8,
                "art_comp": "XCMM0479132",
                "tipoImpianto": "SEEN 15",
                "stock": "NO",
                "art_comp_figlio": "XC0479132",
                "art_comp_nipote": "C0479132"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 11,
                "art_comp": "XCMM0479132",
                "tipoImpianto": "SEEN 15",
                "stock": "NO",
                "art_comp_figlio": "XC0479132",
                "art_comp_nipote": "C0479132"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 11,
                "art_comp": "XCMM0479132",
                "tipoImpianto": "SEEN 15",
                "stock": "NO",
                "art_comp_figlio": "XC0479132",
                "art_comp_nipote": "C0479132"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 12,
                "art_comp": "XCMM0479133",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XC0479133",
                "art_comp_nipote": "C0479133"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 13,
                "art_comp": "XCMM0479132",
                "tipoImpianto": "SEEN 15",
                "stock": "NO",
                "art_comp_figlio": "XC0479132",
                "art_comp_nipote": "C0479132"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 14,
                "art_comp": "XCMM0479133",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XC0479133",
                "art_comp_nipote": "C0479133"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 15,
                "art_comp": "XCMM0479133",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XC0479133",
                "art_comp_nipote": "C0479133"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 15,
                "art_comp": "XMSMM0770111",
                "tipoImpianto": "SEEN 30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770111",
                "art_comp_nipote": "MS0770111"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 18,
                "art_comp": "XCMM0479133",
                "tipoImpianto": "SEEN 20",
                "stock": "NO",
                "art_comp_figlio": "XC0479133",
                "art_comp_nipote": "C0479133"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 19,
                "art_comp": "XMSMM0770111",
                "tipoImpianto": "SEEN 30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770111",
                "art_comp_nipote": "MS0770111"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 20,
                "art_comp": "XCMM0479131",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XC0479131",
                "art_comp_nipote": "C0479131"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 20,
                "art_comp": "XMSMM0770111",
                "tipoImpianto": "SEEN 30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770111",
                "art_comp_nipote": "MS0770111"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 20,
                "art_comp": "XMSMM0770112",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770112",
                "art_comp_nipote": "MS0770112"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 23,
                "art_comp": "XMSMM0770106",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770106",
                "art_comp_nipote": "MS0770106"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 24,
                "art_comp": "XCMM0479131",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XC0479131",
                "art_comp_nipote": "C0479131"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 25,
                "art_comp": "XCMM0479131",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XC0479131",
                "art_comp_nipote": "C0479131"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 25,
                "art_comp": "XMSMM0770109",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770109",
                "art_comp_nipote": "MS0770109"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 25,
                "art_comp": "XMSMM0770111",
                "tipoImpianto": "SEEN 30",
                "stock": "NO",
                "art_comp_figlio": "XMS0770111",
                "art_comp_nipote": "MS0770111"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 26,
                "art_comp": "XMSMM0770112",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770112",
                "art_comp_nipote": "MS0770112"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 27,
                "art_comp": "XMSMM0770112",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770112",
                "art_comp_nipote": "MS0770112"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 28,
                "art_comp": "XMSMM0770107",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770107",
                "art_comp_nipote": "MS0770107"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 30,
                "art_comp": "XCMM0479131",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XC0479131",
                "art_comp_nipote": "C0479131"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 30,
                "art_comp": "XCMM0479131",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XC0479131",
                "art_comp_nipote": "C0479131"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 30,
                "art_comp": "XMSMM0770109",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770109",
                "art_comp_nipote": "MS0770109"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 30,
                "art_comp": "XMSMM0770106",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770106",
                "art_comp_nipote": "MS0770106"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 31,
                "art_comp": "XMSMM0770106",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770106",
                "art_comp_nipote": "MS0770106"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 33,
                "art_comp": "XMSMM0770109",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770109",
                "art_comp_nipote": "MS0770109"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 34,
                "art_comp": "XMSMM0770112",
                "tipoImpianto": "SEEN 35",
                "stock": "NO",
                "art_comp_figlio": "XMS0770112",
                "art_comp_nipote": "MS0770112"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 35,
                "art_comp": "XMSMM0770101",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770101",
                "art_comp_nipote": "MS0770101"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 36,
                "art_comp": "XCMM0479131",
                "tipoImpianto": "SEE 38",
                "stock": "NO",
                "art_comp_figlio": "XC0479131",
                "art_comp_nipote": "C0479131"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 36,
                "art_comp": "XMSMM0770109",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770109",
                "art_comp_nipote": "MS0770109"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 36,
                "art_comp": "XMSMM0770108",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770108",
                "art_comp_nipote": "MS0770108"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 37,
                "art_comp": "XMSMM0770109",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770109",
                "art_comp_nipote": "MS0770109"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 38,
                "art_comp": "XMSMM0770107",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770107",
                "art_comp_nipote": "MS0770107"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 39,
                "art_comp": "XMSMM0770106",
                "tipoImpianto": "SEEN 40",
                "stock": "NO",
                "art_comp_figlio": "XMS0770106",
                "art_comp_nipote": "MS0770106"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 39,
                "art_comp": "XMSMM0770107",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770107",
                "art_comp_nipote": "MS0770107"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 41,
                "art_comp": "XMSMM0770101",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770101",
                "art_comp_nipote": "MS0770101"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 41,
                "art_comp": "XMSMM0770101",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770101",
                "art_comp_nipote": "MS0770101"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 42,
                "art_comp": "XMSMM0770102",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770102",
                "art_comp_nipote": "MS0770102"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 43,
                "art_comp": "XMSMM0770195",
                "tipoImpianto": "SEEN 105",
                "stock": "NO",
                "art_comp_figlio": "XMS0770195",
                "art_comp_nipote": "MS0770195"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 45,
                "art_comp": "XMSMM0770109",
                "tipoImpianto": "SEE 50",
                "stock": "NO",
                "art_comp_figlio": "XMS0770109",
                "art_comp_nipote": "MS0770109"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 48,
                "art_comp": "XMSMM0770101",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770101",
                "art_comp_nipote": "MS0770101"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 48,
                "art_comp": "XMSMM0770110",
                "tipoImpianto": "SEE 90",
                "stock": "NO",
                "art_comp_figlio": "XMS0770110",
                "art_comp_nipote": "MS0770110"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 48,
                "art_comp": "XMSMM0770108",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770108",
                "art_comp_nipote": "MS0770108"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 49,
                "art_comp": "XMSMM0770101",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770101",
                "art_comp_nipote": "MS0770101"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 49,
                "art_comp": "XMSMM0770107",
                "tipoImpianto": "SEEN 55",
                "stock": "NO",
                "art_comp_figlio": "XMS0770107",
                "art_comp_nipote": "MS0770107"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 50,
                "art_comp": "XMSMM0770102",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770102",
                "art_comp_nipote": "MS0770102"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 50,
                "art_comp": "XMSMM0770102",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770102",
                "art_comp_nipote": "MS0770102"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 50,
                "art_comp": "XMSMM0770108",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770108",
                "art_comp_nipote": "MS0770108"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 56,
                "art_comp": "XMSMM0770101",
                "tipoImpianto": "SEE 70",
                "stock": "NO",
                "art_comp_figlio": "XMS0770101",
                "art_comp_nipote": "MS0770101"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 56,
                "art_comp": "XMSMM0770103",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770103",
                "art_comp_nipote": "MS0770103"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 57,
                "art_comp": "XMSMM0770102",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770102",
                "art_comp_nipote": "MS0770102"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 57,
                "art_comp": "XMSMM0770110",
                "tipoImpianto": "SEE 90",
                "stock": "NO",
                "art_comp_figlio": "XMS0770110",
                "art_comp_nipote": "MS0770110"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 59,
                "art_comp": "XMSMM0770102",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770102",
                "art_comp_nipote": "MS0770102"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 59,
                "art_comp": "XMSMM0770110",
                "tipoImpianto": "SEE 90",
                "stock": "NO",
                "art_comp_figlio": "XMS0770110",
                "art_comp_nipote": "MS0770110"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 43,
                "Volume": 62,
                "art_comp": "XMSMM0770196",
                "tipoImpianto": "SEEN 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770196",
                "art_comp_nipote": "MS0770196"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 65,
                "art_comp": "XMSMM0770195",
                "tipoImpianto": "SEEN 105",
                "stock": "NO",
                "art_comp_figlio": "XMS0770195",
                "art_comp_nipote": "MS0770195"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 68,
                "art_comp": "XMSMM0770110",
                "tipoImpianto": "SEE 90",
                "stock": "NO",
                "art_comp_figlio": "XMS0770110",
                "art_comp_nipote": "MS0770110"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 69,
                "art_comp": "XMSMM0770102",
                "tipoImpianto": "SEE 80",
                "stock": "NO",
                "art_comp_figlio": "XMS0770102",
                "art_comp_nipote": "MS0770102"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 69,
                "art_comp": "XMSMM0770103",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770103",
                "art_comp_nipote": "MS0770103"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 69,
                "art_comp": "XMSMM0770108",
                "tipoImpianto": "SEEN 85",
                "stock": "NO",
                "art_comp_figlio": "XMS0770108",
                "art_comp_nipote": "MS0770108"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 71,
                "art_comp": "XMSMM0770110",
                "tipoImpianto": "SEE 90",
                "stock": "NO",
                "art_comp_figlio": "XMS0770110",
                "art_comp_nipote": "MS0770110"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 71,
                "art_comp": "XMSMM0770195",
                "tipoImpianto": "SEEN 105",
                "stock": "NO",
                "art_comp_figlio": "XMS0770195",
                "art_comp_nipote": "MS0770195"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 73,
                "art_comp": "XMSMM0770104",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770104",
                "art_comp_nipote": "MS0770104"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 74,
                "art_comp": "XMSMM0770103",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770103",
                "art_comp_nipote": "MS0770103"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 79,
                "art_comp": "XMSMM0770103",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770103",
                "art_comp_nipote": "MS0770103"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 86,
                "art_comp": "XMSMM0770104",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770104",
                "art_comp_nipote": "MS0770104"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 88,
                "art_comp": "XMSMM0770105",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770105",
                "art_comp_nipote": "MS0770105"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 91,
                "art_comp": "XMSMM0770110",
                "tipoImpianto": "SEE 90",
                "stock": "NO",
                "art_comp_figlio": "XMS0770110",
                "art_comp_nipote": "MS0770110"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 93,
                "art_comp": "XMSMM0770103",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770103",
                "art_comp_nipote": "MS0770103"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 95,
                "art_comp": "XMSMM0770104",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770104",
                "art_comp_nipote": "MS0770104"
              },
              {
                "IdTemperaturaInterna": "-23/-25",
                "IdTemperaturaEsterna": 32,
                "Volume": 95,
                "art_comp": "XMSMM0770196",
                "tipoImpianto": "SEEN 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770196",
                "art_comp_nipote": "MS0770196"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 100,
                "art_comp": "XMSMM0770104",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770104",
                "art_comp_nipote": "MS0770104"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 100,
                "art_comp": "XMSMM0770195",
                "tipoImpianto": "SEEN 105",
                "stock": "NO",
                "art_comp_figlio": "XMS0770195",
                "art_comp_nipote": "MS0770195"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 101,
                "art_comp": "XMSMM0770105",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770105",
                "art_comp_nipote": "MS0770105"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 43,
                "Volume": 103,
                "art_comp": "XMSMM0770194",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770194",
                "art_comp_nipote": "MS0770194"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 111,
                "art_comp": "XMSMM0770105",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770105",
                "art_comp_nipote": "MS0770105"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 43,
                "Volume": 113,
                "art_comp": "XMSMM0770196",
                "tipoImpianto": "SEEN 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770196",
                "art_comp_nipote": "MS0770196"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 43,
                "Volume": 115,
                "art_comp": "XMSMM0770194",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770194",
                "art_comp_nipote": "MS0770194"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 117,
                "art_comp": "XMSMM0770105",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770105",
                "art_comp_nipote": "MS0770105"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 118,
                "art_comp": "XMSMM0770104",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770104",
                "art_comp_nipote": "MS0770104"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 127,
                "art_comp": "XMSMM0770103",
                "tipoImpianto": "SEE 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770103",
                "art_comp_nipote": "MS0770103"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 43,
                "Volume": 137,
                "art_comp": "XMSMM0770194",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770194",
                "art_comp_nipote": "MS0770194"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 139,
                "art_comp": "XMSMM0770105",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770105",
                "art_comp_nipote": "MS0770105"
              },
              {
                "IdTemperaturaInterna": "-2/+2",
                "IdTemperaturaEsterna": 32,
                "Volume": 140,
                "art_comp": "XMSMM0770194",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770194",
                "art_comp_nipote": "MS0770194"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 164,
                "art_comp": "XMSMM0770104",
                "tipoImpianto": "SEE 135",
                "stock": "NO",
                "art_comp_figlio": "XMS0770104",
                "art_comp_nipote": "MS0770104"
              },
              {
                "IdTemperaturaInterna": "-18/-20",
                "IdTemperaturaEsterna": 32,
                "Volume": 164,
                "art_comp": "XMSMM0770196",
                "tipoImpianto": "SEEN 125",
                "stock": "NO",
                "art_comp_figlio": "XMS0770196",
                "art_comp_nipote": "MS0770196"
              },
              {
                "IdTemperaturaInterna": "+2/+4",
                "IdTemperaturaEsterna": 32,
                "Volume": 178,
                "art_comp": "XMSMM0770194",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770194",
                "art_comp_nipote": "MS0770194"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 193,
                "art_comp": "XMSMM0770105",
                "tipoImpianto": "SEE 165",
                "stock": "NO",
                "art_comp_figlio": "XMS0770105",
                "art_comp_nipote": "MS0770105"
              },
              {
                "IdTemperaturaInterna": "+6/+8",
                "IdTemperaturaEsterna": 32,
                "Volume": 264,
                "art_comp": "XMSMM0770194",
                "tipoImpianto": "SEE 200",
                "stock": "NO",
                "art_comp_figlio": "XMS0770194",
                "art_comp_nipote": "MS0770194"
              }
            ]
    }
  }
}
